import gql from 'graphql-tag';
import * as Urql from 'urql';
export var ChatMentionTypeEnum;
(function (ChatMentionTypeEnum) {
    ChatMentionTypeEnum["Everyone"] = "EVERYONE";
    ChatMentionTypeEnum["Room"] = "ROOM";
    ChatMentionTypeEnum["User"] = "USER";
})(ChatMentionTypeEnum || (ChatMentionTypeEnum = {}));
export var ChatRoomTypeEnum;
(function (ChatRoomTypeEnum) {
    ChatRoomTypeEnum["Dm"] = "DM";
    ChatRoomTypeEnum["Family"] = "FAMILY";
    ChatRoomTypeEnum["Private"] = "PRIVATE";
    ChatRoomTypeEnum["Public"] = "PUBLIC";
})(ChatRoomTypeEnum || (ChatRoomTypeEnum = {}));
export var EmailOutboxStatusEnumType;
(function (EmailOutboxStatusEnumType) {
    EmailOutboxStatusEnumType["Failed"] = "FAILED";
    EmailOutboxStatusEnumType["Pending"] = "PENDING";
    EmailOutboxStatusEnumType["Processed"] = "PROCESSED";
    EmailOutboxStatusEnumType["Processing"] = "PROCESSING";
    EmailOutboxStatusEnumType["Published"] = "PUBLISHED";
})(EmailOutboxStatusEnumType || (EmailOutboxStatusEnumType = {}));
export var EmailOutboxTypeEnumType;
(function (EmailOutboxTypeEnumType) {
    EmailOutboxTypeEnumType["AdminForceResetPassword"] = "ADMIN_FORCE_RESET_PASSWORD";
    EmailOutboxTypeEnumType["AppBugReport"] = "APP_BUG_REPORT";
    EmailOutboxTypeEnumType["DirectReferralForCaregivers"] = "DIRECT_REFERRAL_FOR_CAREGIVERS";
    EmailOutboxTypeEnumType["HelpRequest"] = "HELP_REQUEST";
    EmailOutboxTypeEnumType["NewAccountTemporaryPassword"] = "NEW_ACCOUNT_TEMPORARY_PASSWORD";
    EmailOutboxTypeEnumType["PriorityGlobalInvite"] = "PRIORITY_GLOBAL_INVITE";
    EmailOutboxTypeEnumType["PriorityOrganizationInvite"] = "PRIORITY_ORGANIZATION_INVITE";
    EmailOutboxTypeEnumType["PriorityPublicInvite"] = "PRIORITY_PUBLIC_INVITE";
    EmailOutboxTypeEnumType["PriorityReferralForAdmins"] = "PRIORITY_REFERRAL_FOR_ADMINS";
    EmailOutboxTypeEnumType["PriorityReferralReceived"] = "PRIORITY_REFERRAL_RECEIVED";
    EmailOutboxTypeEnumType["QueueInviteReceived"] = "QUEUE_INVITE_RECEIVED";
    EmailOutboxTypeEnumType["WebsiteLeadAccepted"] = "WEBSITE_LEAD_ACCEPTED";
    EmailOutboxTypeEnumType["WebsiteLeadReceived"] = "WEBSITE_LEAD_RECEIVED";
})(EmailOutboxTypeEnumType || (EmailOutboxTypeEnumType = {}));
export var EmailSettingEnumType;
(function (EmailSettingEnumType) {
    EmailSettingEnumType["PriorityReferralReceived"] = "PRIORITY_REFERRAL_RECEIVED";
    EmailSettingEnumType["QueueInviteReceived"] = "QUEUE_INVITE_RECEIVED";
    EmailSettingEnumType["WebsiteLeadReceived"] = "WEBSITE_LEAD_RECEIVED";
})(EmailSettingEnumType || (EmailSettingEnumType = {}));
export var FamilyInviteType;
(function (FamilyInviteType) {
    FamilyInviteType["OrganizationInvite"] = "ORGANIZATION_INVITE";
    FamilyInviteType["Referral"] = "REFERRAL";
})(FamilyInviteType || (FamilyInviteType = {}));
export var FamilyPriorityProgressStatus;
(function (FamilyPriorityProgressStatus) {
    FamilyPriorityProgressStatus["Accepted"] = "ACCEPTED";
    FamilyPriorityProgressStatus["Active"] = "ACTIVE";
    FamilyPriorityProgressStatus["Contacted"] = "CONTACTED";
    FamilyPriorityProgressStatus["Processing"] = "PROCESSING";
    FamilyPriorityProgressStatus["WaitingForProvider"] = "WAITING_FOR_PROVIDER";
})(FamilyPriorityProgressStatus || (FamilyPriorityProgressStatus = {}));
export var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum["CsvUpload"] = "CSV_UPLOAD";
    FileTypeEnum["DocumentUpload"] = "DOCUMENT_UPLOAD";
    FileTypeEnum["ImageUpload"] = "IMAGE_UPLOAD";
    FileTypeEnum["OtherUpload"] = "OTHER_UPLOAD";
    FileTypeEnum["PdfUpload"] = "PDF_UPLOAD";
    FileTypeEnum["VideoUpload"] = "VIDEO_UPLOAD";
    FileTypeEnum["ZipUpload"] = "ZIP_UPLOAD";
})(FileTypeEnum || (FileTypeEnum = {}));
export var ImagePrefixEnum;
(function (ImagePrefixEnum) {
    ImagePrefixEnum["Avatars"] = "AVATARS";
    ImagePrefixEnum["Locations"] = "LOCATIONS";
    ImagePrefixEnum["QueueNotes"] = "QUEUE_NOTES";
})(ImagePrefixEnum || (ImagePrefixEnum = {}));
export var OrganizationTypesEnum;
(function (OrganizationTypesEnum) {
    OrganizationTypesEnum["AbaCenter"] = "ABA_CENTER";
    OrganizationTypesEnum["CoordinationCenter"] = "COORDINATION_CENTER";
    OrganizationTypesEnum["Hospital"] = "HOSPITAL";
    OrganizationTypesEnum["Nonprofit"] = "NONPROFIT";
    OrganizationTypesEnum["School"] = "SCHOOL";
    OrganizationTypesEnum["TherapyClinic"] = "THERAPY_CLINIC";
})(OrganizationTypesEnum || (OrganizationTypesEnum = {}));
export var PermissionEnum;
(function (PermissionEnum) {
    PermissionEnum["AiQuery"] = "AI_QUERY";
    PermissionEnum["AiReadSummaries"] = "AI_READ_SUMMARIES";
    PermissionEnum["AiRerunQuery"] = "AI_RERUN_QUERY";
    PermissionEnum["BugReportsCreate"] = "BUG_REPORTS_CREATE";
    PermissionEnum["ChatMessagesCreate"] = "CHAT_MESSAGES_CREATE";
    PermissionEnum["ChatMessagesDelete"] = "CHAT_MESSAGES_DELETE";
    PermissionEnum["ChatMessagesRead"] = "CHAT_MESSAGES_READ";
    PermissionEnum["ChatMessagesUpdate"] = "CHAT_MESSAGES_UPDATE";
    PermissionEnum["ChatRoomsCreate"] = "CHAT_ROOMS_CREATE";
    PermissionEnum["ChatRoomsDelete"] = "CHAT_ROOMS_DELETE";
    PermissionEnum["ChatRoomsManage"] = "CHAT_ROOMS_MANAGE";
    PermissionEnum["ChatRoomsRead"] = "CHAT_ROOMS_READ";
    PermissionEnum["ChatRoomsUpdate"] = "CHAT_ROOMS_UPDATE";
    PermissionEnum["ConditionsCreate"] = "CONDITIONS_CREATE";
    PermissionEnum["ConditionsDelete"] = "CONDITIONS_DELETE";
    PermissionEnum["ConditionsRead"] = "CONDITIONS_READ";
    PermissionEnum["ConditionsUpdate"] = "CONDITIONS_UPDATE";
    PermissionEnum["DataExport"] = "DATA_EXPORT";
    PermissionEnum["EmailOutboxCreate"] = "EMAIL_OUTBOX_CREATE";
    PermissionEnum["EmailSettingsRead"] = "EMAIL_SETTINGS_READ";
    PermissionEnum["EmailSettingsUpdate"] = "EMAIL_SETTINGS_UPDATE";
    PermissionEnum["FilesCreate"] = "FILES_CREATE";
    PermissionEnum["FilesDelete"] = "FILES_DELETE";
    PermissionEnum["FilesDownload"] = "FILES_DOWNLOAD";
    PermissionEnum["FilesRead"] = "FILES_READ";
    PermissionEnum["FilesReadAdminMetadata"] = "FILES_READ_ADMIN_METADATA";
    PermissionEnum["FilesUpdate"] = "FILES_UPDATE";
    PermissionEnum["HelpRequestsCreate"] = "HELP_REQUESTS_CREATE";
    PermissionEnum["ImagesReadDetails"] = "IMAGES_READ_DETAILS";
    PermissionEnum["ImagesUpload"] = "IMAGES_UPLOAD";
    PermissionEnum["InsurancesCreate"] = "INSURANCES_CREATE";
    PermissionEnum["InsurancesDelete"] = "INSURANCES_DELETE";
    PermissionEnum["InsurancesRead"] = "INSURANCES_READ";
    PermissionEnum["InsurancesUpdate"] = "INSURANCES_UPDATE";
    PermissionEnum["LocationsCreate"] = "LOCATIONS_CREATE";
    PermissionEnum["LocationsDelete"] = "LOCATIONS_DELETE";
    PermissionEnum["LocationsRead"] = "LOCATIONS_READ";
    PermissionEnum["LocationsUpdate"] = "LOCATIONS_UPDATE";
    PermissionEnum["OrganizationsCreate"] = "ORGANIZATIONS_CREATE";
    PermissionEnum["OrganizationsDelete"] = "ORGANIZATIONS_DELETE";
    PermissionEnum["OrganizationsRead"] = "ORGANIZATIONS_READ";
    PermissionEnum["OrganizationsReadDashboard"] = "ORGANIZATIONS_READ_DASHBOARD";
    PermissionEnum["OrganizationsReadDashboardMetrics"] = "ORGANIZATIONS_READ_DASHBOARD_METRICS";
    PermissionEnum["OrganizationsReadDirectory"] = "ORGANIZATIONS_READ_DIRECTORY";
    PermissionEnum["OrganizationsReadIntakeMetrics"] = "ORGANIZATIONS_READ_INTAKE_METRICS";
    PermissionEnum["OrganizationsReadList"] = "ORGANIZATIONS_READ_LIST";
    PermissionEnum["OrganizationsReadSensitive"] = "ORGANIZATIONS_READ_SENSITIVE";
    PermissionEnum["OrganizationsUpdate"] = "ORGANIZATIONS_UPDATE";
    PermissionEnum["OrganizationsUpdateSettings"] = "ORGANIZATIONS_UPDATE_SETTINGS";
    PermissionEnum["PatientsCanBeAssigned"] = "PATIENTS_CAN_BE_ASSIGNED";
    PermissionEnum["PatientsCreate"] = "PATIENTS_CREATE";
    PermissionEnum["PatientsDelete"] = "PATIENTS_DELETE";
    PermissionEnum["PatientsRead"] = "PATIENTS_READ";
    PermissionEnum["PatientsReadDirectory"] = "PATIENTS_READ_DIRECTORY";
    PermissionEnum["PatientsUpdate"] = "PATIENTS_UPDATE";
    PermissionEnum["PatientAssignmentsLink"] = "PATIENT_ASSIGNMENTS_LINK";
    PermissionEnum["PostalCodesCreate"] = "POSTAL_CODES_CREATE";
    PermissionEnum["PostalCodesDelete"] = "POSTAL_CODES_DELETE";
    PermissionEnum["PostalCodesRead"] = "POSTAL_CODES_READ";
    PermissionEnum["PostalCodesUpdate"] = "POSTAL_CODES_UPDATE";
    PermissionEnum["PriorityAttributesUpdate"] = "PRIORITY_ATTRIBUTES_UPDATE";
    PermissionEnum["PriorityAttributesUpdateAndSendSimpleEmail"] = "PRIORITY_ATTRIBUTES_UPDATE_AND_SEND_SIMPLE_EMAIL";
    PermissionEnum["PriorityEmailRecordsCreate"] = "PRIORITY_EMAIL_RECORDS_CREATE";
    PermissionEnum["PriorityEmailRecordsDelete"] = "PRIORITY_EMAIL_RECORDS_DELETE";
    PermissionEnum["PriorityEmailRecordsRead"] = "PRIORITY_EMAIL_RECORDS_READ";
    PermissionEnum["PriorityEmailRecordsReadRelationships"] = "PRIORITY_EMAIL_RECORDS_READ_RELATIONSHIPS";
    PermissionEnum["PriorityEmailRecordsResend"] = "PRIORITY_EMAIL_RECORDS_RESEND";
    PermissionEnum["PriorityEntriesCreate"] = "PRIORITY_ENTRIES_CREATE";
    PermissionEnum["PriorityEntriesExport"] = "PRIORITY_ENTRIES_EXPORT";
    PermissionEnum["PriorityEntriesRead"] = "PRIORITY_ENTRIES_READ";
    PermissionEnum["PriorityEntriesReadCount"] = "PRIORITY_ENTRIES_READ_COUNT";
    PermissionEnum["PriorityInvitesCreate"] = "PRIORITY_INVITES_CREATE";
    PermissionEnum["PriorityInvitesDelete"] = "PRIORITY_INVITES_DELETE";
    PermissionEnum["PriorityInvitesRead"] = "PRIORITY_INVITES_READ";
    PermissionEnum["PriorityInvitesReadRelationships"] = "PRIORITY_INVITES_READ_RELATIONSHIPS";
    PermissionEnum["PriorityInvitesResend"] = "PRIORITY_INVITES_RESEND";
    PermissionEnum["PriorityNotesCreate"] = "PRIORITY_NOTES_CREATE";
    PermissionEnum["PriorityNotesRead"] = "PRIORITY_NOTES_READ";
    PermissionEnum["PriorityReferralsArchive"] = "PRIORITY_REFERRALS_ARCHIVE";
    PermissionEnum["PriorityReferralsCreate"] = "PRIORITY_REFERRALS_CREATE";
    PermissionEnum["PriorityReferralsMoveToPriorityEntry"] = "PRIORITY_REFERRALS_MOVE_TO_PRIORITY_ENTRY";
    PermissionEnum["PriorityReferralsRead"] = "PRIORITY_REFERRALS_READ";
    PermissionEnum["PriorityReferralsReadAdmin"] = "PRIORITY_REFERRALS_READ_ADMIN";
    PermissionEnum["PriorityReferralsRestore"] = "PRIORITY_REFERRALS_RESTORE";
    PermissionEnum["PriorityStatusesCreate"] = "PRIORITY_STATUSES_CREATE";
    PermissionEnum["PriorityStatusesDeleteAndReplace"] = "PRIORITY_STATUSES_DELETE_AND_REPLACE";
    PermissionEnum["PriorityStatusesRead"] = "PRIORITY_STATUSES_READ";
    PermissionEnum["PriorityStatusesReorder"] = "PRIORITY_STATUSES_REORDER";
    PermissionEnum["PriorityStatusesUpdate"] = "PRIORITY_STATUSES_UPDATE";
    PermissionEnum["PriorityViewsCreate"] = "PRIORITY_VIEWS_CREATE";
    PermissionEnum["PriorityViewsDelete"] = "PRIORITY_VIEWS_DELETE";
    PermissionEnum["PriorityViewsRead"] = "PRIORITY_VIEWS_READ";
    PermissionEnum["PriorityViewsReorder"] = "PRIORITY_VIEWS_REORDER";
    PermissionEnum["PriorityViewsUpdate"] = "PRIORITY_VIEWS_UPDATE";
    PermissionEnum["PublicConditionsRead"] = "PUBLIC_CONDITIONS_READ";
    PermissionEnum["PublicEmailPreferencesRead"] = "PUBLIC_EMAIL_PREFERENCES_READ";
    PermissionEnum["PublicEmailPreferencesUnsubscribe"] = "PUBLIC_EMAIL_PREFERENCES_UNSUBSCRIBE";
    PermissionEnum["PublicEmailPreferencesUpdate"] = "PUBLIC_EMAIL_PREFERENCES_UPDATE";
    PermissionEnum["PublicFamilyCaregiverAccountsCompleteCreation"] = "PUBLIC_FAMILY_CAREGIVER_ACCOUNTS_COMPLETE_CREATION";
    PermissionEnum["PublicFamilyCaregiverAccountsPrepareCreation"] = "PUBLIC_FAMILY_CAREGIVER_ACCOUNTS_PREPARE_CREATION";
    PermissionEnum["PublicFamilyCaregiverAccountsStartCreation"] = "PUBLIC_FAMILY_CAREGIVER_ACCOUNTS_START_CREATION";
    PermissionEnum["PublicFamilyCaregiverAccountsStartPasswordReset"] = "PUBLIC_FAMILY_CAREGIVER_ACCOUNTS_START_PASSWORD_RESET";
    PermissionEnum["PublicFilesCreate"] = "PUBLIC_FILES_CREATE";
    PermissionEnum["PublicInsurancesRead"] = "PUBLIC_INSURANCES_READ";
    PermissionEnum["PublicOrganizationsRead"] = "PUBLIC_ORGANIZATIONS_READ";
    PermissionEnum["PublicPriorityEmailRecordsRead"] = "PUBLIC_PRIORITY_EMAIL_RECORDS_READ";
    PermissionEnum["PublicPriorityEmailRecordsUpdate"] = "PUBLIC_PRIORITY_EMAIL_RECORDS_UPDATE";
    PermissionEnum["PublicPriorityEntriesCreate"] = "PUBLIC_PRIORITY_ENTRIES_CREATE";
    PermissionEnum["PublicPriorityEntriesRead"] = "PUBLIC_PRIORITY_ENTRIES_READ";
    PermissionEnum["PublicPriorityReferralsSubscribe"] = "PUBLIC_PRIORITY_REFERRALS_SUBSCRIBE";
    PermissionEnum["PublicPriorityReferralsUpdate"] = "PUBLIC_PRIORITY_REFERRALS_UPDATE";
    PermissionEnum["PublicTherapyCategoriesRead"] = "PUBLIC_THERAPY_CATEGORIES_READ";
    PermissionEnum["PublicTherapySubcategoriesRead"] = "PUBLIC_THERAPY_SUBCATEGORIES_READ";
    PermissionEnum["PublicWebsiteLeadsCreate"] = "PUBLIC_WEBSITE_LEADS_CREATE";
    PermissionEnum["PublicWebsiteLeadsSubscribe"] = "PUBLIC_WEBSITE_LEADS_SUBSCRIBE";
    PermissionEnum["SimpleEmailTemplatesCreate"] = "SIMPLE_EMAIL_TEMPLATES_CREATE";
    PermissionEnum["SimpleEmailTemplatesDelete"] = "SIMPLE_EMAIL_TEMPLATES_DELETE";
    PermissionEnum["SimpleEmailTemplatesRead"] = "SIMPLE_EMAIL_TEMPLATES_READ";
    PermissionEnum["SimpleEmailTemplatesUpdate"] = "SIMPLE_EMAIL_TEMPLATES_UPDATE";
    PermissionEnum["TherapyCategoriesCreate"] = "THERAPY_CATEGORIES_CREATE";
    PermissionEnum["TherapyCategoriesDelete"] = "THERAPY_CATEGORIES_DELETE";
    PermissionEnum["TherapyCategoriesRead"] = "THERAPY_CATEGORIES_READ";
    PermissionEnum["TherapyCategoriesUpdate"] = "THERAPY_CATEGORIES_UPDATE";
    PermissionEnum["TherapySubcategoriesCreate"] = "THERAPY_SUBCATEGORIES_CREATE";
    PermissionEnum["TherapySubcategoriesDelete"] = "THERAPY_SUBCATEGORIES_DELETE";
    PermissionEnum["TherapySubcategoriesRead"] = "THERAPY_SUBCATEGORIES_READ";
    PermissionEnum["TherapySubcategoriesUpdate"] = "THERAPY_SUBCATEGORIES_UPDATE";
    PermissionEnum["UsersCreate"] = "USERS_CREATE";
    PermissionEnum["UsersDelete"] = "USERS_DELETE";
    PermissionEnum["UsersMasquerade"] = "USERS_MASQUERADE";
    PermissionEnum["UsersRead"] = "USERS_READ";
    PermissionEnum["UsersReadDirectory"] = "USERS_READ_DIRECTORY";
    PermissionEnum["UsersReadOrganization"] = "USERS_READ_ORGANIZATION";
    PermissionEnum["UsersReadSelf"] = "USERS_READ_SELF";
    PermissionEnum["UsersResetPassword"] = "USERS_RESET_PASSWORD";
    PermissionEnum["UsersUpdate"] = "USERS_UPDATE";
    PermissionEnum["WebsiteLeadsArchive"] = "WEBSITE_LEADS_ARCHIVE";
    PermissionEnum["WebsiteLeadsMoveToPriorityEntry"] = "WEBSITE_LEADS_MOVE_TO_PRIORITY_ENTRY";
    PermissionEnum["WebsiteLeadsRead"] = "WEBSITE_LEADS_READ";
    PermissionEnum["WebsiteLeadsRestore"] = "WEBSITE_LEADS_RESTORE";
})(PermissionEnum || (PermissionEnum = {}));
export var PreferredLanguage;
(function (PreferredLanguage) {
    PreferredLanguage["AmericanSignLanguageAsl"] = "AMERICAN_SIGN_LANGUAGE__ASL_";
    PreferredLanguage["Arabic"] = "ARABIC";
    PreferredLanguage["Armenian"] = "ARMENIAN";
    PreferredLanguage["Bosnian"] = "BOSNIAN";
    PreferredLanguage["Cantonese"] = "CANTONESE";
    PreferredLanguage["Croatian"] = "CROATIAN";
    PreferredLanguage["English"] = "ENGLISH";
    PreferredLanguage["Farsi"] = "FARSI";
    PreferredLanguage["Filipino"] = "FILIPINO";
    PreferredLanguage["French"] = "FRENCH";
    PreferredLanguage["German"] = "GERMAN";
    PreferredLanguage["Greek"] = "GREEK";
    PreferredLanguage["Gujarati"] = "GUJARATI";
    PreferredLanguage["HatianCreole"] = "HATIAN_CREOLE";
    PreferredLanguage["Hebrew"] = "HEBREW";
    PreferredLanguage["Hindi"] = "HINDI";
    PreferredLanguage["Hungarian"] = "HUNGARIAN";
    PreferredLanguage["Italian"] = "ITALIAN";
    PreferredLanguage["Japanese"] = "JAPANESE";
    PreferredLanguage["Korean"] = "KOREAN";
    PreferredLanguage["Mandarin"] = "MANDARIN";
    PreferredLanguage["Polish"] = "POLISH";
    PreferredLanguage["Portuguese"] = "PORTUGUESE";
    PreferredLanguage["Punjabi"] = "PUNJABI";
    PreferredLanguage["Romanian"] = "ROMANIAN";
    PreferredLanguage["Russian"] = "RUSSIAN";
    PreferredLanguage["Serbian"] = "SERBIAN";
    PreferredLanguage["Sinhalese"] = "SINHALESE";
    PreferredLanguage["Spanish"] = "SPANISH";
    PreferredLanguage["Turkish"] = "TURKISH";
    PreferredLanguage["Ukrainian"] = "UKRAINIAN";
    PreferredLanguage["Urdu"] = "URDU";
    PreferredLanguage["Vietnamese"] = "VIETNAMESE";
})(PreferredLanguage || (PreferredLanguage = {}));
export var PriorityEmailAction;
(function (PriorityEmailAction) {
    PriorityEmailAction["PriorityGlobalInviteAccept"] = "PRIORITY_GLOBAL_INVITE_ACCEPT";
    PriorityEmailAction["PriorityGlobalInviteDecline"] = "PRIORITY_GLOBAL_INVITE_DECLINE";
    PriorityEmailAction["PriorityOrganizationInviteAccept"] = "PRIORITY_ORGANIZATION_INVITE_ACCEPT";
    PriorityEmailAction["PriorityOrganizationInviteDecline"] = "PRIORITY_ORGANIZATION_INVITE_DECLINE";
})(PriorityEmailAction || (PriorityEmailAction = {}));
export var PriorityEmailType;
(function (PriorityEmailType) {
    PriorityEmailType["PriorityGlobalInvite"] = "PRIORITY_GLOBAL_INVITE";
    PriorityEmailType["PriorityOrganizationInvite"] = "PRIORITY_ORGANIZATION_INVITE";
    PriorityEmailType["PriorityReferralForCaregivers"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS";
})(PriorityEmailType || (PriorityEmailType = {}));
export var PriorityNoteNoteType;
(function (PriorityNoteNoteType) {
    PriorityNoteNoteType["System"] = "SYSTEM";
    PriorityNoteNoteType["User"] = "USER";
})(PriorityNoteNoteType || (PriorityNoteNoteType = {}));
export var PriorityReferralActionEnum;
(function (PriorityReferralActionEnum) {
    PriorityReferralActionEnum["PriorityReferralForCaregiversAccept"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS_ACCEPT";
    PriorityReferralActionEnum["PriorityReferralForCaregiversDecline"] = "PRIORITY_REFERRAL_FOR_CAREGIVERS_DECLINE";
})(PriorityReferralActionEnum || (PriorityReferralActionEnum = {}));
export var PrioritySearchMatch;
(function (PrioritySearchMatch) {
    PrioritySearchMatch["All"] = "ALL";
    PrioritySearchMatch["Any"] = "ANY";
    PrioritySearchMatch["None"] = "NONE";
})(PrioritySearchMatch || (PrioritySearchMatch = {}));
export var PrioritySearchSortKey;
(function (PrioritySearchSortKey) {
    PrioritySearchSortKey["InquiredAt"] = "INQUIRED_AT";
})(PrioritySearchSortKey || (PrioritySearchSortKey = {}));
export var PrioritySearchSortOrder;
(function (PrioritySearchSortOrder) {
    PrioritySearchSortOrder["Asc"] = "ASC";
    PrioritySearchSortOrder["Desc"] = "DESC";
})(PrioritySearchSortOrder || (PrioritySearchSortOrder = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["CaseManager"] = "CaseManager";
    UserRoleEnum["OrganizationAdmin"] = "OrganizationAdmin";
    UserRoleEnum["OrganizationOwner"] = "OrganizationOwner";
    UserRoleEnum["Provider"] = "Provider";
})(UserRoleEnum || (UserRoleEnum = {}));
export const CreateConditionDocument = gql `
    mutation CreateCondition($name: String!) {
  conditions {
    createCondition(name: $name) {
      conditionId
      name
      isActive
    }
  }
}
    `;
export function useCreateConditionMutation() {
    return Urql.useMutation(CreateConditionDocument);
}
;
export const UpdateConditionDocument = gql `
    mutation UpdateCondition($conditionId: String!, $name: String, $isActive: Boolean) {
  conditions {
    updateCondition(conditionId: $conditionId, name: $name, isActive: $isActive) {
      conditionId
      name
      isActive
    }
  }
}
    `;
export function useUpdateConditionMutation() {
    return Urql.useMutation(UpdateConditionDocument);
}
;
export const DeleteConditionDocument = gql `
    mutation DeleteCondition($conditionId: String!) {
  conditions {
    deleteCondition(conditionId: $conditionId) {
      conditionId
    }
  }
}
    `;
export function useDeleteConditionMutation() {
    return Urql.useMutation(DeleteConditionDocument);
}
;
export const GetConditionCountDocument = gql `
    query GetConditionCount($search: String) {
  conditions {
    conditionCount(search: $search)
  }
}
    `;
export function useGetConditionCountQuery(options) {
    return Urql.useQuery({ query: GetConditionCountDocument, ...options });
}
;
export const GetConditionsDocument = gql `
    query GetConditions($search: String, $offset: Int) {
  conditions {
    conditions(search: $search, offset: $offset) {
      conditionId
      name
      isActive
    }
  }
}
    `;
export function useGetConditionsQuery(options) {
    return Urql.useQuery({ query: GetConditionsDocument, ...options });
}
;
export const GetConditionListDocument = gql `
    query GetConditionList {
  conditions {
    conditionsList {
      value
      label
    }
  }
}
    `;
export function useGetConditionListQuery(options) {
    return Urql.useQuery({ query: GetConditionListDocument, ...options });
}
;
export const GetUploadFilePresignedUrlDocument = gql `
    mutation GetUploadFilePresignedUrl($input: UploadFilePresignedUrlInput!) {
  files {
    createUploadFilePresignedUrl(input: $input) {
      presignedUrl
    }
  }
}
    `;
export function useGetUploadFilePresignedUrlMutation() {
    return Urql.useMutation(GetUploadFilePresignedUrlDocument);
}
;
export const CreateFileRecordDocument = gql `
    mutation CreateFileRecord($input: CreateFileInput!) {
  files {
    createFileRecord(input: $input) {
      fileId
      name
      fileName
      fileType
      fileSize
      mimeType
      isOriginatingOrganization
      isShared
      tags
      createdAt
    }
  }
}
    `;
export function useCreateFileRecordMutation() {
    return Urql.useMutation(CreateFileRecordDocument);
}
;
export const UpdateFileRecordDocument = gql `
    mutation UpdateFileRecord($input: UpdateFileInput!) {
  files {
    updateFileRecord(input: $input) {
      fileId
      name
      fileType
      tags
    }
  }
}
    `;
export function useUpdateFileRecordMutation() {
    return Urql.useMutation(UpdateFileRecordDocument);
}
;
export const GetPresignedFileDownloadUrlDocument = gql `
    mutation GetPresignedFileDownloadUrl($fileId: String!) {
  files {
    downloadFilePresignedUrl(fileId: $fileId) {
      presignedUrl
    }
  }
}
    `;
export function useGetPresignedFileDownloadUrlMutation() {
    return Urql.useMutation(GetPresignedFileDownloadUrlDocument);
}
;
export const DeleteFileDocument = gql `
    mutation DeleteFile($fileId: String!) {
  files {
    deleteFile(fileId: $fileId)
  }
}
    `;
export function useDeleteFileMutation() {
    return Urql.useMutation(DeleteFileDocument);
}
;
export const GetFilesCountDocument = gql `
    query GetFilesCount($search: String, $caregiverId: String, $patientId: String, $fileTypes: [String]) {
  files {
    fileCount(
      search: $search
      caregiverId: $caregiverId
      patientId: $patientId
      fileTypes: $fileTypes
    )
  }
}
    `;
export function useGetFilesCountQuery(options) {
    return Urql.useQuery({ query: GetFilesCountDocument, ...options });
}
;
export const GetFilesDocument = gql `
    query GetFiles($search: String, $offset: Int, $caregiverId: String, $patientId: String, $fileTypes: [String]) {
  files {
    files(
      search: $search
      offset: $offset
      caregiverId: $caregiverId
      patientId: $patientId
      fileTypes: $fileTypes
    ) {
      fileId
      isOriginatingOrganization
      name
      fileName
      fileType
      fileSize
      mimeType
      tags
      isShared
      createdAt
      originatingOrganization {
        organizationId
        name
      }
    }
  }
}
    `;
export function useGetFilesQuery(options) {
    return Urql.useQuery({ query: GetFilesDocument, ...options });
}
;
export const GetCaregiverAndPatientInfoForFileUploadDocument = gql `
    query GetCaregiverAndPatientInfoForFileUpload($priorityEntryId: String!) {
  priorityEntries {
    priorityEntry(priorityEntryId: $priorityEntryId) {
      priorityEntryId
      caregiverId
      patientId
    }
  }
}
    `;
export function useGetCaregiverAndPatientInfoForFileUploadQuery(options) {
    return Urql.useQuery({ query: GetCaregiverAndPatientInfoForFileUploadDocument, ...options });
}
;
export const CreateInsuranceDocument = gql `
    mutation CreateInsurance($name: String!) {
  insurances {
    createInsurance(name: $name) {
      insuranceId
      name
      isActive
    }
  }
}
    `;
export function useCreateInsuranceMutation() {
    return Urql.useMutation(CreateInsuranceDocument);
}
;
export const UpdateInsuranceDocument = gql `
    mutation UpdateInsurance($insuranceId: String!, $name: String, $isActive: Boolean) {
  insurances {
    updateInsurance(insuranceId: $insuranceId, name: $name, isActive: $isActive) {
      insuranceId
      name
      isActive
    }
  }
}
    `;
export function useUpdateInsuranceMutation() {
    return Urql.useMutation(UpdateInsuranceDocument);
}
;
export const DeleteInsuranceDocument = gql `
    mutation DeleteInsurance($insuranceId: String!) {
  insurances {
    deleteInsurance(insuranceId: $insuranceId) {
      insuranceId
    }
  }
}
    `;
export function useDeleteInsuranceMutation() {
    return Urql.useMutation(DeleteInsuranceDocument);
}
;
export const GetInsuranceCountDocument = gql `
    query GetInsuranceCount($search: String) {
  insurances {
    insuranceCount(search: $search)
  }
}
    `;
export function useGetInsuranceCountQuery(options) {
    return Urql.useQuery({ query: GetInsuranceCountDocument, ...options });
}
;
export const GetInsurancesDocument = gql `
    query GetInsurances($search: String, $offset: Int) {
  insurances {
    insurances(search: $search, offset: $offset) {
      insuranceId
      name
      isActive
    }
  }
}
    `;
export function useGetInsurancesQuery(options) {
    return Urql.useQuery({ query: GetInsurancesDocument, ...options });
}
;
export const CreateLocationDocument = gql `
    mutation CreateLocation($name: String!, $address1: String, $address2: String, $city: String, $stateName: String, $postalCode: String, $isPrimary: Boolean, $imageKey: String, $imageVersion: String) {
  locations {
    createLocation(
      input: {name: $name, address1: $address1, address2: $address2, city: $city, stateName: $stateName, postalCode: $postalCode, isPrimary: $isPrimary, imageKey: $imageKey, imageVersion: $imageVersion}
    ) {
      locationId
      organizationId
      organizationName
      name
      address1
      address2
      city
      stateId
      stateName
      postalCode
      isPrimary
      isActive
      imageUrl
    }
  }
}
    `;
export function useCreateLocationMutation() {
    return Urql.useMutation(CreateLocationDocument);
}
;
export const UpdateLocationDocument = gql `
    mutation UpdateLocation($locationId: String!, $name: String, $address1: String, $address2: String, $city: String, $stateName: String, $postalCode: String, $isPrimary: Boolean, $imageKey: String, $imageVersion: String, $latitude: Float, $longitude: Float, $isActive: Boolean) {
  locations {
    updateLocation(
      input: {locationId: $locationId, name: $name, address1: $address1, address2: $address2, city: $city, stateName: $stateName, postalCode: $postalCode, isPrimary: $isPrimary, imageKey: $imageKey, imageVersion: $imageVersion, latitude: $latitude, longitude: $longitude, isActive: $isActive}
    ) {
      locationId
      organizationId
      organizationName
      name
      address1
      address2
      city
      stateId
      stateName
      postalCode
      isPrimary
      isActive
      imageUrl
    }
  }
}
    `;
export function useUpdateLocationMutation() {
    return Urql.useMutation(UpdateLocationDocument);
}
;
export const DeleteLocationDocument = gql `
    mutation DeleteLocation($locationId: String!) {
  locations {
    deleteLocation(locationId: $locationId) {
      locationId
    }
  }
}
    `;
export function useDeleteLocationMutation() {
    return Urql.useMutation(DeleteLocationDocument);
}
;
export const GetLocationCountDocument = gql `
    query GetLocationCount($search: String, $organizationId: String) {
  locations {
    locationCount(search: $search, organizationId: $organizationId)
  }
}
    `;
export function useGetLocationCountQuery(options) {
    return Urql.useQuery({ query: GetLocationCountDocument, ...options });
}
;
export const GetLocationsDocument = gql `
    query GetLocations($search: String, $offset: Int, $organizationId: String) {
  locations {
    locations(search: $search, offset: $offset, organizationId: $organizationId) {
      locationId
      organizationId
      name
      address1
      address2
      city
      stateId
      stateName
      postalCode
      isPrimary
      isActive
      imageUrl
      createdAt
      updatedAt
    }
  }
}
    `;
export function useGetLocationsQuery(options) {
    return Urql.useQuery({ query: GetLocationsDocument, ...options });
}
;
export const GetLocationDocument = gql `
    query GetLocation($locationId: String!, $organizationId: String) {
  locations {
    location(locationId: $locationId, organizationId: $organizationId) {
      locationId
      organizationId
      organizationName
      name
      address1
      address2
      city
      stateId
      stateName
      postalCode
      latitude
      longitude
      isPrimary
      isActive
      imageUrl
    }
  }
}
    `;
export function useGetLocationQuery(options) {
    return Urql.useQuery({ query: GetLocationDocument, ...options });
}
;
export const GetLocationListDocument = gql `
    query GetLocationList($organizationId: String) {
  locations {
    locationsList(organizationId: $organizationId) {
      value
      label
    }
  }
}
    `;
export function useGetLocationListQuery(options) {
    return Urql.useQuery({ query: GetLocationListDocument, ...options });
}
;
export const GetLocationPostalCodesDocument = gql `
    query GetLocationPostalCodes {
  locations {
    locations {
      locationId
      postalCode
    }
  }
}
    `;
export function useGetLocationPostalCodesQuery(options) {
    return Urql.useQuery({ query: GetLocationPostalCodesDocument, ...options });
}
;
export const CreateOrganizationDocument = gql `
    mutation CreateOrganization($name: String!, $npiNumber: String!, $about: String, $email: String!, $phoneNumber: String!, $notes: String, $insuranceIds: [String!], $imageKey: String, $organizationTypes: [OrganizationTypesEnum!], $websiteUrl: String, $imageVersion: String, $therapyCategoryIds: [String!]) {
  organizations {
    createOrganization(
      input: {name: $name, npiNumber: $npiNumber, about: $about, email: $email, phoneNumber: $phoneNumber, notes: $notes, insuranceIds: $insuranceIds, websiteUrl: $websiteUrl, organizationTypes: $organizationTypes, imageKey: $imageKey, imageVersion: $imageVersion, therapyCategoryIds: $therapyCategoryIds}
    ) {
      organizationId
      npiNumber
      name
      email
      phoneNumber
      organizationTypes
      about
      notes
      imageUrl
      isActive
      createdAt
      updatedAt
      acceptedTermsConditionsAt
    }
  }
}
    `;
export function useCreateOrganizationMutation() {
    return Urql.useMutation(CreateOrganizationDocument);
}
;
export const UpdateOrganizationDocument = gql `
    mutation UpdateOrganization($organizationId: String!, $name: String, $npiNumber: String, $email: String, $phoneNumber: String, $about: String, $notes: String, $insuranceIds: [String!], $organizationTypes: [OrganizationTypesEnum!], $websiteUrl: String, $imageKey: String, $imageVersion: String, $therapyCategoryIds: [String!], $isActive: Boolean) {
  organizations {
    updateOrganization(
      input: {organizationId: $organizationId, name: $name, npiNumber: $npiNumber, about: $about, email: $email, notes: $notes, phoneNumber: $phoneNumber, insuranceIds: $insuranceIds, organizationTypes: $organizationTypes, websiteUrl: $websiteUrl, imageKey: $imageKey, imageVersion: $imageVersion, therapyCategoryIds: $therapyCategoryIds, isActive: $isActive}
    ) {
      organizationId
      npiNumber
      name
      email
      phoneNumber
      organizationTypes
      websiteUrl
      about
      notes
      imageUrl
      isActive
      createdAt
      updatedAt
      acceptedTermsConditionsAt
    }
  }
}
    `;
export function useUpdateOrganizationMutation() {
    return Urql.useMutation(UpdateOrganizationDocument);
}
;
export const DeleteOrganizationDocument = gql `
    mutation DeleteOrganization($organizationId: String!) {
  organizations {
    deleteOrganization(organizationId: $organizationId) {
      organizationId
    }
  }
}
    `;
export function useDeleteOrganizationMutation() {
    return Urql.useMutation(DeleteOrganizationDocument);
}
;
export const GetOrganizationCountDocument = gql `
    query GetOrganizationCount($search: String) {
  organizations {
    organizationCount(search: $search)
  }
}
    `;
export function useGetOrganizationCountQuery(options) {
    return Urql.useQuery({ query: GetOrganizationCountDocument, ...options });
}
;
export const GetOrganizationsDocument = gql `
    query GetOrganizations($search: String, $offset: Int) {
  organizations {
    organizations(search: $search, offset: $offset) {
      organizationId
      npiNumber
      name
      email
      phoneNumber
      organizationTypes
      imageUrl
      isActive
    }
  }
}
    `;
export function useGetOrganizationsQuery(options) {
    return Urql.useQuery({ query: GetOrganizationsDocument, ...options });
}
;
export const GetOrganizationDetailsDocument = gql `
    query GetOrganizationDetails($organizationId: String!) {
  organizations {
    organization(organizationId: $organizationId) {
      organizationId
      name
      npiNumber
      email
      phoneNumber
      organizationTypes
      websiteUrl
      about
      notes
      imageUrl
      isActive
      createdAt
      insuranceList {
        value
        label
      }
      therapyCategoryList {
        value
        label
      }
    }
  }
}
    `;
export function useGetOrganizationDetailsQuery(options) {
    return Urql.useQuery({ query: GetOrganizationDetailsDocument, ...options });
}
;
export const GetOrganizationListDocument = gql `
    query GetOrganizationList {
  organizations {
    organizationList {
      value
      label
      imageUrl
    }
  }
}
    `;
export function useGetOrganizationListQuery(options) {
    return Urql.useQuery({ query: GetOrganizationListDocument, ...options });
}
;
export const GetOrganizationDashboardDocument = gql `
    query GetOrganizationDashboard($startDate: String, $endDate: String) {
  organizations {
    organizationDashboard(startDate: $startDate, endDate: $endDate) {
      referralPipelineCount
      pipelineReferralsWithoutAssignedProviderCount
      inboundTriageCount
      directReferralCount
      directReferralsReceivedCount
      websiteLeadCount
      websiteLeadsMovedToPipelineCount
      globalReferralInvitePendingCount
      staleReferralPipelineCount
      pendingInviteCount
    }
  }
}
    `;
export function useGetOrganizationDashboardQuery(options) {
    return Urql.useQuery({ query: GetOrganizationDashboardDocument, ...options });
}
;
export const UpdateEmailSettingDocument = gql `
    mutation UpdateEmailSetting($input: EmailSettingUpdateInput!) {
  emailSettings {
    updateEmailSettings(input: $input) {
      emailSettingId
      toUsers {
        userId
        name
        imageUrl
        email
      }
      emailSettingType
      isEnabled
    }
  }
}
    `;
export function useUpdateEmailSettingMutation() {
    return Urql.useMutation(UpdateEmailSettingDocument);
}
;
export const UpdateOrganizationIntakeFormDocument = gql `
    mutation UpdateOrganizationIntakeForm($input: OrganizationSettingsUpdateInput!) {
  organizations {
    updateOrganizationSettings(input: $input) {
      organizationId
      settings {
        intakeForm {
          isActive
          url
        }
      }
    }
  }
}
    `;
export function useUpdateOrganizationIntakeFormMutation() {
    return Urql.useMutation(UpdateOrganizationIntakeFormDocument);
}
;
export const GetOrganizationSettingsDocument = gql `
    query GetOrganizationSettings {
  organizations {
    organization {
      organizationId
      settings {
        intakeForm {
          isActive
          url
        }
      }
    }
  }
  emailSettings {
    emailSettings {
      emailSettingId
      toUsers {
        userId
        name
        imageUrl
        email
      }
      emailSettingType
      isEnabled
    }
  }
}
    `;
export function useGetOrganizationSettingsQuery(options) {
    return Urql.useQuery({ query: GetOrganizationSettingsDocument, ...options });
}
;
export const CreatePatientDocument = gql `
    mutation CreatePatient($input: PatientCreateInput!) {
  patients {
    createPatient(input: $input) {
      patientId
      caregiverId
      firstName
      lastName
      dateOfBirth
      postalCode
      isActive
      createdAt
    }
  }
}
    `;
export function useCreatePatientMutation() {
    return Urql.useMutation(CreatePatientDocument);
}
;
export const UpdatePatientDocument = gql `
    mutation UpdatePatient($input: PatientUpdateInput!) {
  patients {
    updatePatient(input: $input) {
      patientId
      caregiverId
      firstName
      lastName
      dateOfBirth
      preferredLanguages
      daysAvailable
      timeAvailable
      postalCode
      isActive
      createdAt
      providers {
        userId
        firstName
        lastName
        imageUrl
      }
      conditionList {
        label
        value
      }
      insuranceList {
        label
        value
      }
      therapyCategoryList {
        label
        value
      }
      therapySubCategoryList {
        label
        value
      }
    }
  }
}
    `;
export function useUpdatePatientMutation() {
    return Urql.useMutation(UpdatePatientDocument);
}
;
export const DeletePatientDocument = gql `
    mutation DeletePatient($patientId: String!) {
  patients {
    deletePatient(patientId: $patientId) {
      patientId
    }
  }
}
    `;
export function useDeletePatientMutation() {
    return Urql.useMutation(DeletePatientDocument);
}
;
export const GetPatientCountDocument = gql `
    query GetPatientCount($search: String) {
  patients {
    patientCount(search: $search)
  }
}
    `;
export function useGetPatientCountQuery(options) {
    return Urql.useQuery({ query: GetPatientCountDocument, ...options });
}
;
export const GetPatientsDocument = gql `
    query GetPatients($search: String, $offset: Int) {
  patients {
    patients(search: $search, offset: $offset) {
      patientId
      caregiverId
      firstName
      lastName
      dateOfBirth
      preferredLanguages
      daysAvailable
      timeAvailable
      postalCode
      isActive
      createdAt
      postalCodeInfo {
        city
        stateId
      }
    }
  }
}
    `;
export function useGetPatientsQuery(options) {
    return Urql.useQuery({ query: GetPatientsDocument, ...options });
}
;
export const GetPatientDocument = gql `
    query GetPatient($patientId: String!) {
  patients {
    patient(patientId: $patientId) {
      patientId
      caregiverId
      firstName
      lastName
      dateOfBirth
      preferredLanguages
      daysAvailable
      timeAvailable
      postalCode
      gradeLevel
      isActive
      createdAt
      caregiver {
        userId
        firstName
        lastName
      }
      providers {
        userId
        firstName
        lastName
        imageUrl
      }
      postalCodeInfo {
        city
        stateId
      }
      conditionList {
        label
        value
      }
      insuranceList {
        label
        value
      }
      therapyCategoryList {
        label
        value
      }
      therapySubCategoryList {
        label
        value
      }
    }
  }
}
    `;
export function useGetPatientQuery(options) {
    return Urql.useQuery({ query: GetPatientDocument, ...options });
}
;
export const AssignPatientsToProviderDocument = gql `
    mutation AssignPatientsToProvider($input: PatientsToProviderInput!) {
  patientAssignments {
    linkProviderToPatients(input: $input) {
      providerId
      provider {
        userId
        numberOfPatients
      }
    }
  }
}
    `;
export function useAssignPatientsToProviderMutation() {
    return Urql.useMutation(AssignPatientsToProviderDocument);
}
;
export const AssignProvidersToPatientDocument = gql `
    mutation AssignProvidersToPatient($input: ProvidersToPatientInput!) {
  patientAssignments {
    linkPatientToProviders(input: $input) {
      patientId
      priorityEntries {
        priorityEntryId
        providers {
          userId
          firstName
          lastName
          imageUrl
        }
      }
    }
  }
}
    `;
export function useAssignProvidersToPatientMutation() {
    return Urql.useMutation(AssignProvidersToPatientDocument);
}
;
export const GetProviderAndPatientsDocument = gql `
    query GetProviderAndPatients($providerId: String!) {
  users {
    user(userId: $providerId) {
      userId
      firstName
      lastName
      imageUrl
      patients {
        patientId
      }
    }
  }
  organizations {
    organization {
      organizationId
      patients {
        patientId
        firstName
        lastName
      }
    }
  }
}
    `;
export function useGetProviderAndPatientsQuery(options) {
    return Urql.useQuery({ query: GetProviderAndPatientsDocument, ...options });
}
;
export const GetPatientAndProvidersDocument = gql `
    query GetPatientAndProviders($patientId: String!) {
  patients {
    patient(patientId: $patientId) {
      patientId
      firstName
      lastName
      providers {
        userId
      }
    }
  }
  users {
    users(roleNames: [Provider]) {
      userId
      firstName
      lastName
      imageUrl
    }
  }
}
    `;
export function useGetPatientAndProvidersQuery(options) {
    return Urql.useQuery({ query: GetPatientAndProvidersDocument, ...options });
}
;
export const CreatePostalCodeDocument = gql `
    mutation CreatePostalCode($postalCode: String!, $latitude: Float, $longitude: Float, $city: String!, $stateName: String!, $countyName: String, $timezone: String) {
  postalCodes {
    createPostalCode(
      postalCode: $postalCode
      latitude: $latitude
      longitude: $longitude
      city: $city
      stateName: $stateName
      countyName: $countyName
      timezone: $timezone
    ) {
      postalCodeId
      postalCode
      latitude
      longitude
      city
      stateId
      stateName
      countyName
      timezone
      isActive
    }
  }
}
    `;
export function useCreatePostalCodeMutation() {
    return Urql.useMutation(CreatePostalCodeDocument);
}
;
export const UpdatePostalCodeDocument = gql `
    mutation UpdatePostalCode($postalCodeId: String!, $postalCode: String, $latitude: Float, $longitude: Float, $city: String, $stateName: String, $countyName: String, $timezone: String, $isActive: Boolean) {
  postalCodes {
    updatePostalCode(
      postalCodeId: $postalCodeId
      postalCode: $postalCode
      latitude: $latitude
      longitude: $longitude
      city: $city
      stateName: $stateName
      countyName: $countyName
      timezone: $timezone
      isActive: $isActive
    ) {
      postalCodeId
      postalCode
      latitude
      longitude
      city
      stateId
      stateName
      countyName
      timezone
      isActive
    }
  }
}
    `;
export function useUpdatePostalCodeMutation() {
    return Urql.useMutation(UpdatePostalCodeDocument);
}
;
export const DeletePostalCodeDocument = gql `
    mutation DeletePostalCode($postalCodeId: String!) {
  postalCodes {
    deletePostalCode(postalCodeId: $postalCodeId) {
      postalCodeId
    }
  }
}
    `;
export function useDeletePostalCodeMutation() {
    return Urql.useMutation(DeletePostalCodeDocument);
}
;
export const GetPostalCodeCountDocument = gql `
    query GetPostalCodeCount($search: String) {
  postalCodes {
    postalCodeCount(search: $search)
  }
}
    `;
export function useGetPostalCodeCountQuery(options) {
    return Urql.useQuery({ query: GetPostalCodeCountDocument, ...options });
}
;
export const GetPostalCodesDocument = gql `
    query GetPostalCodes($search: String, $offset: Int) {
  postalCodes {
    postalCodes(search: $search, offset: $offset) {
      postalCodeId
      postalCode
      latitude
      longitude
      city
      stateId
      stateName
      countyName
      timezone
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;
export function useGetPostalCodesQuery(options) {
    return Urql.useQuery({ query: GetPostalCodesDocument, ...options });
}
;
export const GetPostalCodeDocument = gql `
    query GetPostalCode($postalCodeId: String, $postalCode: String) {
  postalCodes {
    postalCode(postalCodeId: $postalCodeId, postalCode: $postalCode) {
      postalCodeId
      postalCode
      latitude
      longitude
      city
      stateId
      stateName
      countyName
      timezone
      isActive
    }
  }
}
    `;
export function useGetPostalCodeQuery(options) {
    return Urql.useQuery({ query: GetPostalCodeDocument, ...options });
}
;
export const CreateUnifiedPriorityEntryDocument = gql `
    mutation CreateUnifiedPriorityEntry($input: UnifiedPriorityEntryInput!) {
  priorityEntries {
    createUnifiedPriorityEntry(input: $input) {
      priorityEntryId
      providers(matchTherapyCategory: true) {
        userId
        firstName
        lastName
        imageUrl
      }
      priorityAttribute {
        priorityAttributeId
        inquiredAt
        priorityStatus {
          priorityStatusId
          name
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      caregiver {
        userId
        firstName
        lastName
      }
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
      }
    }
  }
}
    `;
export function useCreateUnifiedPriorityEntryMutation() {
    return Urql.useMutation(CreateUnifiedPriorityEntryDocument);
}
;
export const GetPriorityEntryCountDocument = gql `
    query GetPriorityEntryCount($search: PrioritySearchInput!) {
  priorityEntries {
    priorityEntryCount(search: $search)
  }
}
    `;
export function useGetPriorityEntryCountQuery(options) {
    return Urql.useQuery({ query: GetPriorityEntryCountDocument, ...options });
}
;
export const GetPriorityEntryDetailsDocument = gql `
    query GetPriorityEntryDetails($priorityEntryId: String!) {
  priorityEntries {
    priorityEntry(priorityEntryId: $priorityEntryId) {
      priorityEntryId
      isGlobal
      isOriginatingOrganization
      isAdoptingOrganization
      isReferredOrganization
      patientId
      caregiverId
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
        preferredLanguages
        daysAvailable
        timeAvailable
        postalCode
        gradeLevel
        conditionList {
          value
          label
        }
        insuranceList {
          value
          label
        }
        therapyCategoryList {
          value
          label
        }
        therapySubCategoryList {
          value
          label
        }
        postalCodeInfo {
          city
          stateId
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      caregiver {
        userId
        firstName
        lastName
        email
        phoneNumber
        acceptedTermsConditionsAt
        createdAt
        updatedAt
        isActive
      }
      invitationPending
      providers {
        userId
        firstName
        lastName
      }
      priorityAttribute {
        priorityAttributeId
        tags
        isReferral
        inquiredAt
        priorityStatus {
          priorityStatusId
          name
          colorHex
          isMutable
          sortOrder
          throwConfetti
          simpleEmailTemplateId
        }
      }
      relatedEntries {
        priorityEntryId
        therapyCategoryName
      }
    }
  }
}
    `;
export function useGetPriorityEntryDetailsQuery(options) {
    return Urql.useQuery({ query: GetPriorityEntryDetailsDocument, ...options });
}
;
export const ExportPriorityEntriesDocument = gql `
    query ExportPriorityEntries($priorityViewId: String!) {
  priorityEntries {
    exportPriorityEntries(priorityViewId: $priorityViewId) {
      priorityEntryId
      caregiver {
        userId
        firstName
        lastName
        email
        phoneNumber
      }
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
        postalCodeInfo {
          city
          stateId
          postalCode
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      priorityAttribute {
        priorityAttributeId
        inquiredAt
        priorityStatus {
          priorityStatusId
          name
        }
      }
    }
  }
}
    `;
export function useExportPriorityEntriesQuery(options) {
    return Urql.useQuery({ query: ExportPriorityEntriesDocument, ...options });
}
;
export const GetPriorityEntrySearchResultsDocument = gql `
    query GetPriorityEntrySearchResults($search: PrioritySearchInput!, $matchTherapyCategory: Boolean) {
  priorityEntries {
    priorityEntries(search: $search) {
      priorityEntryId
      isGlobal
      isOriginatingOrganization
      isAdoptingOrganization
      isReferredOrganization
      caregiver {
        userId
        firstName
        lastName
      }
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
        postalCodeInfo {
          city
          stateId
          postalCode
        }
      }
      invitationPending
      providers(matchTherapyCategory: $matchTherapyCategory) {
        userId
        firstName
        lastName
      }
      priorityAttribute {
        priorityAttributeId
        priorityStatus {
          priorityStatusId
          name
          colorHex
          isMutable
          simpleEmailTemplateId
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
    }
  }
}
    `;
export function useGetPriorityEntrySearchResultsQuery(options) {
    return Urql.useQuery({ query: GetPriorityEntrySearchResultsDocument, ...options });
}
;
export const SendPriorityPublicInviteDocument = gql `
    mutation SendPriorityPublicInvite($email: String!, $note: String) {
  priorityInvites {
    createPriorityInvite(email: $email, note: $note) {
      email
      inviteUrl
    }
  }
}
    `;
export function useSendPriorityPublicInviteMutation() {
    return Urql.useMutation(SendPriorityPublicInviteDocument);
}
;
export const ResendPriorityInviteDocument = gql `
    mutation ResendPriorityInvite($priorityInviteId: String!) {
  priorityInvites {
    resendPriorityInvite(priorityInviteId: $priorityInviteId) {
      success
    }
  }
}
    `;
export function useResendPriorityInviteMutation() {
    return Urql.useMutation(ResendPriorityInviteDocument);
}
;
export const DeletePriorityInviteDocument = gql `
    mutation DeletePriorityInvite($inviteId: String!) {
  priorityInvites {
    deletePriorityInvite(inviteId: $inviteId) {
      priorityInviteId
    }
  }
}
    `;
export function useDeletePriorityInviteMutation() {
    return Urql.useMutation(DeletePriorityInviteDocument);
}
;
export const GetOrganizationImageUrlDocument = gql `
    query GetOrganizationImageUrl {
  organizations {
    organization {
      imageUrl
    }
  }
}
    `;
export function useGetOrganizationImageUrlQuery(options) {
    return Urql.useQuery({ query: GetOrganizationImageUrlDocument, ...options });
}
;
export const GetPriorityInvitesDocument = gql `
    query GetPriorityInvites($search: String, $offset: Int) {
  priorityInvites {
    priorityInvites(search: $search, offset: $offset) {
      priorityInviteId
      invitingUser {
        userId
        name
        email
        imageUrl
      }
      email
      isExpired
      acceptedAt
      createdAt
      updatedAt
    }
  }
}
    `;
export function useGetPriorityInvitesQuery(options) {
    return Urql.useQuery({ query: GetPriorityInvitesDocument, ...options });
}
;
export const GetPriorityInviteCountDocument = gql `
    query GetPriorityInviteCount($search: String) {
  priorityInvites {
    priorityInviteCount(search: $search)
  }
}
    `;
export function useGetPriorityInviteCountQuery(options) {
    return Urql.useQuery({ query: GetPriorityInviteCountDocument, ...options });
}
;
export const CreatePriorityNoteDocument = gql `
    mutation CreatePriorityNote($input: PriorityNoteCreate!) {
  priorityNotes {
    createPriorityNote(input: $input) {
      priorityNoteId
      priorityEntryId
      organizationId
      note
      noteType
      contactType
      contactReason
      contactOutcome
      name
      imageUrl
      createdAt
    }
  }
}
    `;
export function useCreatePriorityNoteMutation() {
    return Urql.useMutation(CreatePriorityNoteDocument);
}
;
export const GetPriorityNotesDocument = gql `
    query GetPriorityNotes($caregiverId: String!, $patientId: String!, $search: String) {
  priorityNotes {
    priorityNotes(caregiverId: $caregiverId, patientId: $patientId, search: $search) {
      priorityNoteId
      priorityEntryId
      organizationId
      note
      noteType
      contactType
      contactReason
      contactOutcome
      name
      imageUrl
      createdAt
    }
  }
}
    `;
export function useGetPriorityNotesQuery(options) {
    return Urql.useQuery({ query: GetPriorityNotesDocument, ...options });
}
;
export const CreatePriorityReferralDocument = gql `
    mutation CreatePriorityReferral($input: PriorityReferralInput!) {
  priorityReferrals {
    createPriorityReferral(input: $input) {
      success
    }
  }
}
    `;
export function useCreatePriorityReferralMutation() {
    return Urql.useMutation(CreatePriorityReferralDocument);
}
;
export const MoveReferralToPriorityEntryDocument = gql `
    mutation MoveReferralToPriorityEntry($priorityReferralId: String!) {
  priorityReferrals {
    movePriorityReferralToPriorityEntry(priorityReferralId: $priorityReferralId) {
      priorityReferralId
    }
  }
}
    `;
export function useMoveReferralToPriorityEntryMutation() {
    return Urql.useMutation(MoveReferralToPriorityEntryDocument);
}
;
export const ArchivePriorityReferralDocument = gql `
    mutation ArchivePriorityReferral($priorityReferralId: String!) {
  priorityReferrals {
    archivePriorityReferral(priorityReferralId: $priorityReferralId) {
      priorityReferralId
      archivedAt
    }
  }
}
    `;
export function useArchivePriorityReferralMutation() {
    return Urql.useMutation(ArchivePriorityReferralDocument);
}
;
export const RestorePriorityReferralDocument = gql `
    mutation RestorePriorityReferral($priorityReferralId: String!) {
  priorityReferrals {
    restorePriorityReferral(priorityReferralId: $priorityReferralId) {
      priorityReferralId
      archivedAt
    }
  }
}
    `;
export function useRestorePriorityReferralMutation() {
    return Urql.useMutation(RestorePriorityReferralDocument);
}
;
export const GetReferralCountDocument = gql `
    query GetReferralCount($archived: Boolean!, $search: String, $therapyCategoryIds: [String]) {
  priorityReferrals {
    priorityReferralCount(
      archived: $archived
      search: $search
      therapyCategoryIds: $therapyCategoryIds
    )
  }
}
    `;
export function useGetReferralCountQuery(options) {
    return Urql.useQuery({ query: GetReferralCountDocument, ...options });
}
;
export const GetReferralCountForTherapproveAdminsDocument = gql `
    query GetReferralCountForTherapproveAdmins($search: String) {
  priorityReferrals {
    priorityReferralCountForTherapproveAdmins(search: $search)
  }
}
    `;
export function useGetReferralCountForTherapproveAdminsQuery(options) {
    return Urql.useQuery({ query: GetReferralCountForTherapproveAdminsDocument, ...options });
}
;
export const GetReferralsDocument = gql `
    query GetReferrals($archived: Boolean!, $search: String, $offset: Int, $therapyCategoryIds: [String]) {
  priorityReferrals {
    priorityReferrals(
      archived: $archived
      search: $search
      offset: $offset
      therapyCategoryIds: $therapyCategoryIds
    ) {
      priorityReferralId
      caregiver {
        userId
        firstName
        lastName
        email
        phoneNumber
      }
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
        postalCode
        postalCodeInfo {
          city
          stateId
          postalCode
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      archivedAt
      createdAt
    }
  }
}
    `;
export function useGetReferralsQuery(options) {
    return Urql.useQuery({ query: GetReferralsDocument, ...options });
}
;
export const GetReferralsForTherapproveAdminsDocument = gql `
    query GetReferralsForTherapproveAdmins($search: String, $offset: Int) {
  priorityReferrals {
    priorityReferralsForTherapproveAdmins(search: $search, offset: $offset) {
      priorityReferralId
      originatingUser {
        userId
        name
        email
      }
      originatingOrganization {
        organizationId
        name
        imageUrl
      }
      referralRecipientEmail
      referralRecipientOrganization {
        organizationId
        name
        imageUrl
      }
      priorityReferralAction
      caregiver {
        userId
        firstName
        lastName
        email
        phoneNumber
        acceptedTermsConditionsAt
      }
      patient {
        patientId
        firstName
        lastName
      }
      archivedAt
      updatedAt
      createdAt
    }
  }
}
    `;
export function useGetReferralsForTherapproveAdminsQuery(options) {
    return Urql.useQuery({ query: GetReferralsForTherapproveAdminsDocument, ...options });
}
;
export const PriorityReferralReceivedDocument = gql `
    subscription PriorityReferralReceived {
  priorityReferralReceived {
    priorityReferralId
    caregiver {
      userId
      firstName
      lastName
      email
      phoneNumber
    }
    patient {
      patientId
      firstName
      lastName
      dateOfBirth
      postalCode
      postalCodeInfo {
        city
        stateId
        postalCode
      }
    }
    therapyCategory {
      therapyCategoryId
      name
    }
    archivedAt
    createdAt
  }
}
    `;
export function usePriorityReferralReceivedSubscription(options, handler) {
    return Urql.useSubscription({ query: PriorityReferralReceivedDocument, ...options }, handler);
}
;
export const CreatePriorityStatusDocument = gql `
    mutation CreatePriorityStatus($name: String!, $colorHex: String!, $sortOrder: Int!, $throwConfetti: Boolean, $simpleEmailTemplateId: String) {
  priorityStatuses {
    createPriorityStatus(
      input: {name: $name, colorHex: $colorHex, sortOrder: $sortOrder, throwConfetti: $throwConfetti, simpleEmailTemplateId: $simpleEmailTemplateId}
    ) {
      priorityStatusId
      name
      colorHex
      sortOrder
      isMutable
      throwConfetti
      simpleEmailTemplateId
    }
  }
}
    `;
export function useCreatePriorityStatusMutation() {
    return Urql.useMutation(CreatePriorityStatusDocument);
}
;
export const UpdatePriorityStatusDocument = gql `
    mutation UpdatePriorityStatus($priorityStatusId: String!, $name: String, $colorHex: String, $sortOrder: Int, $throwConfetti: Boolean, $simpleEmailTemplateId: String) {
  priorityStatuses {
    updatePriorityStatus(
      input: {priorityStatusId: $priorityStatusId, name: $name, colorHex: $colorHex, sortOrder: $sortOrder, throwConfetti: $throwConfetti, simpleEmailTemplateId: $simpleEmailTemplateId}
    ) {
      priorityStatusId
      name
      colorHex
      sortOrder
      isMutable
      throwConfetti
      simpleEmailTemplateId
    }
  }
}
    `;
export function useUpdatePriorityStatusMutation() {
    return Urql.useMutation(UpdatePriorityStatusDocument);
}
;
export const BulkReorderPriorityStatusesDocument = gql `
    mutation BulkReorderPriorityStatuses($input: [BulkReorderInput!]!) {
  priorityStatuses {
    bulkReorderPriorityStatuses(input: $input) {
      priorityStatusId
      sortOrder
    }
  }
}
    `;
export function useBulkReorderPriorityStatusesMutation() {
    return Urql.useMutation(BulkReorderPriorityStatusesDocument);
}
;
export const DeleteAndReplacePriorityStatusDocument = gql `
    mutation DeleteAndReplacePriorityStatus($priorityStatusIdToDelete: String!, $priorityStatusIdToReplaceWith: String!) {
  priorityStatuses {
    deleteAndReplacePriorityStatus(
      priorityStatusIdToDelete: $priorityStatusIdToDelete
      priorityStatusIdToReplaceWith: $priorityStatusIdToReplaceWith
    ) {
      priorityStatusId
    }
  }
}
    `;
export function useDeleteAndReplacePriorityStatusMutation() {
    return Urql.useMutation(DeleteAndReplacePriorityStatusDocument);
}
;
export const GetPriorityStatusesDocument = gql `
    query GetPriorityStatuses {
  priorityStatuses {
    priorityStatuses {
      priorityStatusId
      name
      colorHex
      sortOrder
      throwConfetti
      isMutable
      simpleEmailTemplateId
    }
  }
}
    `;
export function useGetPriorityStatusesQuery(options) {
    return Urql.useQuery({ query: GetPriorityStatusesDocument, ...options });
}
;
export const BulkReorderPriorityViewsDocument = gql `
    mutation BulkReorderPriorityViews($input: [BulkReorderInput!]!) {
  priorityViews {
    bulkReorderPriorityViews(input: $input) {
      priorityViewId
      sortOrder
    }
  }
}
    `;
export function useBulkReorderPriorityViewsMutation() {
    return Urql.useMutation(BulkReorderPriorityViewsDocument);
}
;
export const CreatePriorityViewDocument = gql `
    mutation CreatePriorityView($input: PriorityViewCreate!) {
  priorityViews {
    createPriorityView(input: $input) {
      priorityViewId
      name
      sortOrder
    }
  }
}
    `;
export function useCreatePriorityViewMutation() {
    return Urql.useMutation(CreatePriorityViewDocument);
}
;
export const UpdatePriorityViewDocument = gql `
    mutation UpdatePriorityView($input: PriorityViewUpdate!) {
  priorityViews {
    updatePriorityView(input: $input) {
      priorityViewId
      name
      sortOrder
    }
  }
}
    `;
export function useUpdatePriorityViewMutation() {
    return Urql.useMutation(UpdatePriorityViewDocument);
}
;
export const DeletePriorityViewDocument = gql `
    mutation DeletePriorityView($priorityViewId: String!) {
  priorityViews {
    deletePriorityView(priorityViewId: $priorityViewId) {
      priorityViewId
    }
  }
}
    `;
export function useDeletePriorityViewMutation() {
    return Urql.useMutation(DeletePriorityViewDocument);
}
;
export const GetPriorityViewsDocument = gql `
    query GetPriorityViews {
  priorityViews {
    priorityViews {
      priorityViewId
      organizationId
      name
      filter {
        where {
          organization_id
          is_global
          needs_follow_up {
            value
            amount
            interval
          }
          without_assigned_provider
          search
          age_years {
            older_than
            younger_than
            between
          }
          time_waiting_date {
            longer_than
            shorter_than
            between
          }
          location {
            postal_codes
            distance_in_miles
          }
          days_available {
            names
            match
          }
          priority_status_id {
            ids
            match
          }
          tags {
            names
            match
          }
          condition_ids {
            ids
            match
          }
          therapy_category_ids {
            ids
            match
          }
          therapy_sub_category_ids {
            ids
            match
          }
          insurance_ids {
            ids
            match
          }
        }
        sort {
          field
          order
        }
        pagination {
          limit
          offset
        }
      }
      sortOrder
    }
  }
  priorityStatuses {
    priorityStatuses {
      priorityStatusId
      name
      colorHex
      sortOrder
      throwConfetti
      isMutable
      simpleEmailTemplateId
    }
  }
}
    `;
export function useGetPriorityViewsQuery(options) {
    return Urql.useQuery({ query: GetPriorityViewsDocument, ...options });
}
;
export const CreateSimpleEmailTemplateDocument = gql `
    mutation CreateSimpleEmailTemplate($subject: String!, $body: String!) {
  simpleEmailTemplates {
    createSimpleEmailTemplate(input: {subject: $subject, body: $body}) {
      simpleEmailTemplateId
      organizationId
      subject
      body
      createdAt
      updatedAt
    }
  }
}
    `;
export function useCreateSimpleEmailTemplateMutation() {
    return Urql.useMutation(CreateSimpleEmailTemplateDocument);
}
;
export const UpdateSimpleEmailTemplateDocument = gql `
    mutation UpdateSimpleEmailTemplate($simpleEmailTemplateId: String!, $subject: String, $body: String) {
  simpleEmailTemplates {
    updateSimpleEmailTemplate(
      input: {simpleEmailTemplateId: $simpleEmailTemplateId, subject: $subject, body: $body}
    ) {
      simpleEmailTemplateId
      organizationId
      subject
      body
      createdAt
      updatedAt
    }
  }
}
    `;
export function useUpdateSimpleEmailTemplateMutation() {
    return Urql.useMutation(UpdateSimpleEmailTemplateDocument);
}
;
export const DeleteSimpleEmailTemplateDocument = gql `
    mutation DeleteSimpleEmailTemplate($simpleEmailTemplateId: String!) {
  simpleEmailTemplates {
    deleteSimpleEmailTemplate(simpleEmailTemplateId: $simpleEmailTemplateId) {
      simpleEmailTemplateId
    }
  }
}
    `;
export function useDeleteSimpleEmailTemplateMutation() {
    return Urql.useMutation(DeleteSimpleEmailTemplateDocument);
}
;
export const GetSimpleEmailTemplatesDocument = gql `
    query GetSimpleEmailTemplates($offset: Int) {
  simpleEmailTemplates {
    simpleEmailTemplates(offset: $offset) {
      simpleEmailTemplateId
      organizationId
      subject
      body
      createdAt
      updatedAt
    }
    totalCount: simpleEmailTemplateCount
  }
}
    `;
export function useGetSimpleEmailTemplatesQuery(options) {
    return Urql.useQuery({ query: GetSimpleEmailTemplatesDocument, ...options });
}
;
export const GetSimpleEmailTemplateDocument = gql `
    query GetSimpleEmailTemplate($simpleEmailTemplateId: String!) {
  simpleEmailTemplates {
    simpleEmailTemplate(simpleEmailTemplateId: $simpleEmailTemplateId) {
      simpleEmailTemplateId
      organizationId
      subject
      body
      createdAt
      updatedAt
    }
  }
}
    `;
export function useGetSimpleEmailTemplateQuery(options) {
    return Urql.useQuery({ query: GetSimpleEmailTemplateDocument, ...options });
}
;
export const CreateTherapyCategoryDocument = gql `
    mutation CreateTherapyCategory($name: String!) {
  therapyCategories {
    createTherapyCategory(name: $name) {
      therapyCategoryId
      name
      isActive
    }
  }
}
    `;
export function useCreateTherapyCategoryMutation() {
    return Urql.useMutation(CreateTherapyCategoryDocument);
}
;
export const UpdateTherapyCategoryDocument = gql `
    mutation UpdateTherapyCategory($therapyCategoryId: String!, $name: String, $isActive: Boolean) {
  therapyCategories {
    updateTherapyCategory(
      therapyCategoryId: $therapyCategoryId
      name: $name
      isActive: $isActive
    ) {
      therapyCategoryId
      name
      isActive
    }
  }
}
    `;
export function useUpdateTherapyCategoryMutation() {
    return Urql.useMutation(UpdateTherapyCategoryDocument);
}
;
export const DeleteTherapyCategoryDocument = gql `
    mutation DeleteTherapyCategory($therapyCategoryId: String!) {
  therapyCategories {
    deleteTherapyCategory(therapyCategoryId: $therapyCategoryId) {
      therapyCategoryId
    }
  }
}
    `;
export function useDeleteTherapyCategoryMutation() {
    return Urql.useMutation(DeleteTherapyCategoryDocument);
}
;
export const CreateTherapySubCategoryDocument = gql `
    mutation CreateTherapySubCategory($therapyCategoryId: String!, $name: String!) {
  therapySubCategories {
    createTherapySubCategory(therapyCategoryId: $therapyCategoryId, name: $name) {
      therapySubCategoryId
      name
      isActive
    }
  }
}
    `;
export function useCreateTherapySubCategoryMutation() {
    return Urql.useMutation(CreateTherapySubCategoryDocument);
}
;
export const UpdateTherapySubCategoryDocument = gql `
    mutation UpdateTherapySubCategory($therapySubCategoryId: String!, $therapyCategoryId: String, $name: String, $isActive: Boolean) {
  therapySubCategories {
    updateTherapySubCategory(
      therapySubCategoryId: $therapySubCategoryId
      therapyCategoryId: $therapyCategoryId
      name: $name
      isActive: $isActive
    ) {
      therapySubCategoryId
      name
      isActive
    }
  }
}
    `;
export function useUpdateTherapySubCategoryMutation() {
    return Urql.useMutation(UpdateTherapySubCategoryDocument);
}
;
export const DeleteTherapySubCategoryDocument = gql `
    mutation DeleteTherapySubCategory($therapySubCategoryId: String!) {
  therapySubCategories {
    deleteTherapySubCategory(therapySubCategoryId: $therapySubCategoryId) {
      therapySubCategoryId
    }
  }
}
    `;
export function useDeleteTherapySubCategoryMutation() {
    return Urql.useMutation(DeleteTherapySubCategoryDocument);
}
;
export const GetTherapyCategoriesAndSubCategoriesDocument = gql `
    query GetTherapyCategoriesAndSubCategories($search: String, $offset: Int) {
  therapyCategories {
    therapyCategories(search: $search, offset: $offset) {
      therapyCategoryId
      name
      isActive
      therapySubCategories {
        therapySubCategoryId
        therapyCategoryId
        name
        isActive
      }
    }
  }
}
    `;
export function useGetTherapyCategoriesAndSubCategoriesQuery(options) {
    return Urql.useQuery({ query: GetTherapyCategoriesAndSubCategoriesDocument, ...options });
}
;
export const GetTherapyCategoryListDocument = gql `
    query GetTherapyCategoryList($inOrganization: Boolean) {
  therapyCategories {
    therapyCategoriesList(inOrganization: $inOrganization) {
      value
      label
    }
  }
}
    `;
export function useGetTherapyCategoryListQuery(options) {
    return Urql.useQuery({ query: GetTherapyCategoryListDocument, ...options });
}
;
export const GetTherapySubCategoryGroupsDocument = gql `
    query GetTherapySubCategoryGroups($therapyCategoryIds: [String]) {
  therapySubCategories {
    therapySubCategoryGroups(therapyCategoryIds: $therapyCategoryIds) {
      group
      items {
        value
        label
      }
    }
  }
}
    `;
export function useGetTherapySubCategoryGroupsQuery(options) {
    return Urql.useQuery({ query: GetTherapySubCategoryGroupsDocument, ...options });
}
;
export const MoveLeadToPriorityEntryDocument = gql `
    mutation MoveLeadToPriorityEntry($websiteLeadId: String!) {
  websiteLeads {
    moveWebsiteLeadToPriorityEntry(websiteLeadId: $websiteLeadId) {
      websiteLeadId
      caregiverId
      patientId
      therapyCategoryId
      movedToPipeline
    }
  }
}
    `;
export function useMoveLeadToPriorityEntryMutation() {
    return Urql.useMutation(MoveLeadToPriorityEntryDocument);
}
;
export const ArchiveWebsiteLeadDocument = gql `
    mutation ArchiveWebsiteLead($websiteLeadId: String!) {
  websiteLeads {
    archiveWebsiteLead(websiteLeadId: $websiteLeadId) {
      websiteLeadId
      archivedAt
    }
  }
}
    `;
export function useArchiveWebsiteLeadMutation() {
    return Urql.useMutation(ArchiveWebsiteLeadDocument);
}
;
export const RestoreWebsiteLeadDocument = gql `
    mutation RestoreWebsiteLead($websiteLeadId: String!) {
  websiteLeads {
    restoreWebsiteLead(websiteLeadId: $websiteLeadId) {
      websiteLeadId
      archivedAt
    }
  }
}
    `;
export function useRestoreWebsiteLeadMutation() {
    return Urql.useMutation(RestoreWebsiteLeadDocument);
}
;
export const GetWebsiteLeadCountDocument = gql `
    query GetWebsiteLeadCount($archived: Boolean!, $search: String, $therapyCategoryIds: [String]) {
  websiteLeads {
    websiteLeadCount(
      archived: $archived
      search: $search
      therapyCategoryIds: $therapyCategoryIds
    )
  }
}
    `;
export function useGetWebsiteLeadCountQuery(options) {
    return Urql.useQuery({ query: GetWebsiteLeadCountDocument, ...options });
}
;
export const GetWebsiteLeadsDocument = gql `
    query GetWebsiteLeads($archived: Boolean!, $search: String, $offset: Int, $therapyCategoryIds: [String]) {
  websiteLeads {
    websiteLeads(
      archived: $archived
      search: $search
      offset: $offset
      therapyCategoryIds: $therapyCategoryIds
    ) {
      websiteLeadId
      caregiverId
      patientId
      caregiver {
        userId
        firstName
        lastName
        email
        phoneNumber
      }
      patient {
        patientId
        firstName
        lastName
        dateOfBirth
        postalCode
        postalCodeInfo {
          city
          stateId
          postalCode
        }
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      createdAt
      archivedAt
      movedToPipeline
    }
  }
}
    `;
export function useGetWebsiteLeadsQuery(options) {
    return Urql.useQuery({ query: GetWebsiteLeadsDocument, ...options });
}
;
export const WebsiteLeadReceivedDocument = gql `
    subscription WebsiteLeadReceived {
  websiteLeadReceived {
    websiteLeadId
    caregiverId
    patientId
    caregiver {
      userId
      firstName
      lastName
      email
      phoneNumber
    }
    patient {
      patientId
      firstName
      lastName
      dateOfBirth
      postalCode
      postalCodeInfo {
        city
        stateId
        postalCode
      }
    }
    therapyCategory {
      therapyCategoryId
      name
    }
    createdAt
    archivedAt
    movedToPipeline
  }
}
    `;
export function useWebsiteLeadReceivedSubscription(options, handler) {
    return Urql.useSubscription({ query: WebsiteLeadReceivedDocument, ...options }, handler);
}
;
export const QueryDataWithAiDocument = gql `
    mutation QueryDataWithAI($naturalLanguageQuery: String!, $chatSeriesId: String) {
  ai {
    queryData(
      naturalLanguageQuery: $naturalLanguageQuery
      chatSeriesId: $chatSeriesId
    ) {
      aiQueryRequestId
      chatSeriesId
      notes
      rows
      createdAt
    }
  }
}
    `;
export function useQueryDataWithAiMutation() {
    return Urql.useMutation(QueryDataWithAiDocument);
}
;
export const RerunAiQueryDocument = gql `
    mutation RerunAIQuery($aiQueryRequestId: String!) {
  ai {
    rerunAiSqlQuery(aiQueryRequestId: $aiQueryRequestId) {
      aiQueryRequestId
      rows
    }
  }
}
    `;
export function useRerunAiQueryMutation() {
    return Urql.useMutation(RerunAiQueryDocument);
}
;
export const CreateBugReportDocument = gql `
    mutation CreateBugReport($message: String!) {
  bugReports {
    createBugReport(message: $message) {
      success
    }
  }
}
    `;
export function useCreateBugReportMutation() {
    return Urql.useMutation(CreateBugReportDocument);
}
;
export const SendChatMessageDocument = gql `
    mutation SendChatMessage($input: ChatMessageSendInput!) {
  chatMessages {
    sendMessage(input: $input) {
      chatMessageId
      chatRoomId
      senderUserId
      threadParentId
      content
      contentText
      isEdited
      isDeleted
      threadReplyCount
      threadLastReplyAt
      senderFirstName
      senderLastName
      senderImageUrl
      isPinned
      createdAt
      updatedAt
    }
  }
}
    `;
export function useSendChatMessageMutation() {
    return Urql.useMutation(SendChatMessageDocument);
}
;
export const EditChatMessageDocument = gql `
    mutation EditChatMessage($input: ChatMessageEditInput!) {
  chatMessages {
    editMessage(input: $input) {
      chatMessageId
      chatRoomId
      content
      contentText
      isEdited
      updatedAt
    }
  }
}
    `;
export function useEditChatMessageMutation() {
    return Urql.useMutation(EditChatMessageDocument);
}
;
export const DeleteChatMessageDocument = gql `
    mutation DeleteChatMessage($chatMessageId: String!) {
  chatMessages {
    deleteMessage(chatMessageId: $chatMessageId)
  }
}
    `;
export function useDeleteChatMessageMutation() {
    return Urql.useMutation(DeleteChatMessageDocument);
}
;
export const PinChatMessageDocument = gql `
    mutation PinChatMessage($chatMessageId: String!) {
  chatMessages {
    pinMessage(chatMessageId: $chatMessageId) {
      chatPinId
      chatMessageId
      chatRoomId
      pinnedByUserId
      pinnedAt
    }
  }
}
    `;
export function usePinChatMessageMutation() {
    return Urql.useMutation(PinChatMessageDocument);
}
;
export const UnpinChatMessageDocument = gql `
    mutation UnpinChatMessage($chatMessageId: String!) {
  chatMessages {
    unpinMessage(chatMessageId: $chatMessageId)
  }
}
    `;
export function useUnpinChatMessageMutation() {
    return Urql.useMutation(UnpinChatMessageDocument);
}
;
export const AddChatReactionDocument = gql `
    mutation AddChatReaction($input: ChatReactionInput!) {
  chatMessages {
    addReaction(input: $input)
  }
}
    `;
export function useAddChatReactionMutation() {
    return Urql.useMutation(AddChatReactionDocument);
}
;
export const RemoveChatReactionDocument = gql `
    mutation RemoveChatReaction($input: ChatReactionInput!) {
  chatMessages {
    removeReaction(input: $input)
  }
}
    `;
export function useRemoveChatReactionMutation() {
    return Urql.useMutation(RemoveChatReactionDocument);
}
;
export const CreateChatRoomDocument = gql `
    mutation CreateChatRoom($input: ChatRoomCreateInput!) {
  chatRooms {
    createRoom(input: $input) {
      chatRoomId
      type
      name
      description
      isGroupDm
      isArchived
      lastMessageAt
      createdByUserId
      caregiverId
      patientId
      createdAt
      updatedAt
      members {
        chatRoomMemberId
        userId
        firstName
        lastName
        email
        imageUrl
        lastReadAt
        isMuted
        joinedAt
      }
    }
  }
}
    `;
export function useCreateChatRoomMutation() {
    return Urql.useMutation(CreateChatRoomDocument);
}
;
export const UpdateChatRoomDocument = gql `
    mutation UpdateChatRoom($input: ChatRoomUpdateInput!) {
  chatRooms {
    updateRoom(input: $input) {
      chatRoomId
      name
      description
      updatedAt
    }
  }
}
    `;
export function useUpdateChatRoomMutation() {
    return Urql.useMutation(UpdateChatRoomDocument);
}
;
export const ArchiveChatRoomDocument = gql `
    mutation ArchiveChatRoom($chatRoomId: String!) {
  chatRooms {
    archiveRoom(chatRoomId: $chatRoomId) {
      chatRoomId
      isArchived
      updatedAt
    }
  }
}
    `;
export function useArchiveChatRoomMutation() {
    return Urql.useMutation(ArchiveChatRoomDocument);
}
;
export const UnarchiveChatRoomDocument = gql `
    mutation UnarchiveChatRoom($chatRoomId: String!) {
  chatRooms {
    unarchiveRoom(chatRoomId: $chatRoomId) {
      chatRoomId
      isArchived
      updatedAt
    }
  }
}
    `;
export function useUnarchiveChatRoomMutation() {
    return Urql.useMutation(UnarchiveChatRoomDocument);
}
;
export const AddChatRoomMembersDocument = gql `
    mutation AddChatRoomMembers($chatRoomId: String!, $userIds: [String!]!) {
  chatRooms {
    addMembers(chatRoomId: $chatRoomId, userIds: $userIds)
  }
}
    `;
export function useAddChatRoomMembersMutation() {
    return Urql.useMutation(AddChatRoomMembersDocument);
}
;
export const RemoveChatRoomMemberDocument = gql `
    mutation RemoveChatRoomMember($chatRoomId: String!, $userId: String!) {
  chatRooms {
    removeMember(chatRoomId: $chatRoomId, userId: $userId)
  }
}
    `;
export function useRemoveChatRoomMemberMutation() {
    return Urql.useMutation(RemoveChatRoomMemberDocument);
}
;
export const LeaveChatRoomDocument = gql `
    mutation LeaveChatRoom($chatRoomId: String!) {
  chatRooms {
    leaveRoom(chatRoomId: $chatRoomId)
  }
}
    `;
export function useLeaveChatRoomMutation() {
    return Urql.useMutation(LeaveChatRoomDocument);
}
;
export const MarkChatRoomReadDocument = gql `
    mutation MarkChatRoomRead($chatRoomId: String!) {
  chatRooms {
    markRoomRead(chatRoomId: $chatRoomId)
  }
}
    `;
export function useMarkChatRoomReadMutation() {
    return Urql.useMutation(MarkChatRoomReadDocument);
}
;
export const MuteChatRoomDocument = gql `
    mutation MuteChatRoom($chatRoomId: String!, $isMuted: Boolean!) {
  chatRooms {
    muteRoom(chatRoomId: $chatRoomId, isMuted: $isMuted)
  }
}
    `;
export function useMuteChatRoomMutation() {
    return Urql.useMutation(MuteChatRoomDocument);
}
;
export const CreateChatRoomGroupDocument = gql `
    mutation CreateChatRoomGroup($input: ChatRoomGroupCreateInput!) {
  chatRoomGroups {
    createGroup(input: $input) {
      chatRoomGroupId
      userId
      name
      sortOrder
      createdAt
      updatedAt
    }
  }
}
    `;
export function useCreateChatRoomGroupMutation() {
    return Urql.useMutation(CreateChatRoomGroupDocument);
}
;
export const UpdateChatRoomGroupDocument = gql `
    mutation UpdateChatRoomGroup($input: ChatRoomGroupUpdateInput!) {
  chatRoomGroups {
    updateGroup(input: $input) {
      chatRoomGroupId
      name
      sortOrder
      updatedAt
    }
  }
}
    `;
export function useUpdateChatRoomGroupMutation() {
    return Urql.useMutation(UpdateChatRoomGroupDocument);
}
;
export const DeleteChatRoomGroupDocument = gql `
    mutation DeleteChatRoomGroup($chatRoomGroupId: String!) {
  chatRoomGroups {
    deleteGroup(chatRoomGroupId: $chatRoomGroupId)
  }
}
    `;
export function useDeleteChatRoomGroupMutation() {
    return Urql.useMutation(DeleteChatRoomGroupDocument);
}
;
export const ReorderChatRoomGroupsDocument = gql `
    mutation ReorderChatRoomGroups($input: [ChatRoomGroupReorderInput!]!) {
  chatRoomGroups {
    reorderGroups(input: $input) {
      chatRoomGroupId
      sortOrder
    }
  }
}
    `;
export function useReorderChatRoomGroupsMutation() {
    return Urql.useMutation(ReorderChatRoomGroupsDocument);
}
;
export const AssignRoomToGroupDocument = gql `
    mutation AssignRoomToGroup($chatRoomGroupId: String!, $chatRoomId: String!, $sortOrder: Int) {
  chatRoomGroups {
    assignRoom(
      chatRoomGroupId: $chatRoomGroupId
      chatRoomId: $chatRoomId
      sortOrder: $sortOrder
    )
  }
}
    `;
export function useAssignRoomToGroupMutation() {
    return Urql.useMutation(AssignRoomToGroupDocument);
}
;
export const UnassignRoomFromGroupDocument = gql `
    mutation UnassignRoomFromGroup($chatRoomGroupId: String!, $chatRoomId: String!) {
  chatRoomGroups {
    unassignRoom(chatRoomGroupId: $chatRoomGroupId, chatRoomId: $chatRoomId)
  }
}
    `;
export function useUnassignRoomFromGroupMutation() {
    return Urql.useMutation(UnassignRoomFromGroupDocument);
}
;
export const CreateHelpRequestDocument = gql `
    mutation CreateHelpRequest($message: String!) {
  helpRequests {
    createHelpRequest(message: $message) {
      success
    }
  }
}
    `;
export function useCreateHelpRequestMutation() {
    return Urql.useMutation(CreateHelpRequestDocument);
}
;
export const GetPresignedImageUrlDocument = gql `
    mutation GetPresignedImageUrl($input: PresignedUrlInput!) {
  images {
    presignedUrl(input: $input) {
      presignedUrl
    }
  }
}
    `;
export function useGetPresignedImageUrlMutation() {
    return Urql.useMutation(GetPresignedImageUrlDocument);
}
;
export const GetImageDetailsDocument = gql `
    mutation GetImageDetails($imagePrefix: ImagePrefixEnum!, $imageKey: String!) {
  images {
    imageDetails(imagePrefix: $imagePrefix, imageKey: $imageKey) {
      imageKey
      imageVersion
    }
  }
}
    `;
export function useGetImageDetailsMutation() {
    return Urql.useMutation(GetImageDetailsDocument);
}
;
export const UpdatePriorityAttributeDocument = gql `
    mutation UpdatePriorityAttribute($priorityAttributeId: String!, $priorityStatusId: String, $tags: [String!], $inquiredAt: String) {
  priorityAttributes {
    updatePriorityAttribute(
      priorityAttributeId: $priorityAttributeId
      priorityStatusId: $priorityStatusId
      tags: $tags
      inquiredAt: $inquiredAt
    ) {
      priorityAttributeId
      priorityEntryId
      organizationId
      priorityStatusId
      tags
      inquiredAt
      createdAt
      updatedAt
    }
  }
}
    `;
export function useUpdatePriorityAttributeMutation() {
    return Urql.useMutation(UpdatePriorityAttributeDocument);
}
;
export const UpdatePriorityAttributeAndSendSimpleEmailDocument = gql `
    mutation UpdatePriorityAttributeAndSendSimpleEmail($priorityAttributeId: String!, $priorityStatusId: String!, $subject: String!, $body: String!) {
  priorityAttributes {
    updatePriorityAttributeAndSendSimpleEmail(
      input: {priorityAttributeId: $priorityAttributeId, priorityStatusId: $priorityStatusId, subject: $subject, body: $body}
    ) {
      priorityAttributeId
      priorityEntryId
      organizationId
      priorityStatusId
      tags
      inquiredAt
      createdAt
      updatedAt
    }
  }
}
    `;
export function useUpdatePriorityAttributeAndSendSimpleEmailMutation() {
    return Urql.useMutation(UpdatePriorityAttributeAndSendSimpleEmailDocument);
}
;
export const CreatePriorityEmailRecordDocument = gql `
    mutation CreatePriorityEmailRecord($input: PriorityEmailRecordCreateInput!) {
  priorityEmailRecords {
    createPriorityEmailRecord(input: $input) {
      priorityEmailRecordId
      priorityEntry {
        invitationPending
      }
    }
  }
}
    `;
export function useCreatePriorityEmailRecordMutation() {
    return Urql.useMutation(CreatePriorityEmailRecordDocument);
}
;
export const ResendPriorityEmailRecordEmailDocument = gql `
    mutation ResendPriorityEmailRecordEmail($priorityEmailRecordId: String!) {
  priorityEmailRecords {
    resendPriorityEmailRecord(priorityEmailRecordId: $priorityEmailRecordId) {
      success
    }
  }
}
    `;
export function useResendPriorityEmailRecordEmailMutation() {
    return Urql.useMutation(ResendPriorityEmailRecordEmailDocument);
}
;
export const DeletePriorityEmailRecordDocument = gql `
    mutation DeletePriorityEmailRecord($priorityEmailRecordId: String!) {
  priorityEmailRecords {
    deletePriorityEmailRecord(priorityEmailRecordId: $priorityEmailRecordId) {
      priorityEmailRecordId
    }
  }
}
    `;
export function useDeletePriorityEmailRecordMutation() {
    return Urql.useMutation(DeletePriorityEmailRecordDocument);
}
;
export const AcceptTermsConditionsDocument = gql `
    mutation AcceptTermsConditions {
  users {
    acceptTermsConditions
  }
}
    `;
export function useAcceptTermsConditionsMutation() {
    return Urql.useMutation(AcceptTermsConditionsDocument);
}
;
export const ResetPasswordDocument = gql `
    mutation ResetPassword($userIdToReset: String!, $temporaryPassword: String!) {
  users {
    resetPassword(
      userIdToReset: $userIdToReset
      temporaryPassword: $temporaryPassword
    ) {
      success
    }
  }
}
    `;
export function useResetPasswordMutation() {
    return Urql.useMutation(ResetPasswordDocument);
}
;
export const ActivateUserDocument = gql `
    mutation ActivateUser($userId: String!) {
  users {
    activateUser(userId: $userId) {
      userId
      isActive
    }
  }
}
    `;
export function useActivateUserMutation() {
    return Urql.useMutation(ActivateUserDocument);
}
;
export const DeactivateUserDocument = gql `
    mutation DeactivateUser($userId: String!) {
  users {
    deactivateUser(userId: $userId) {
      userId
      isActive
    }
  }
}
    `;
export function useDeactivateUserMutation() {
    return Urql.useMutation(DeactivateUserDocument);
}
;
export const DeleteUserDocument = gql `
    mutation DeleteUser($userId: String!) {
  users {
    deleteUser(userId: $userId) {
      userId
    }
  }
}
    `;
export function useDeleteUserMutation() {
    return Urql.useMutation(DeleteUserDocument);
}
;
export const CreateUserDocument = gql `
    mutation CreateUser($input: UserCreateInput!) {
  users {
    createUser(input: $input) {
      userId
      firstName
      lastName
      email
      phoneNumber
      isActive
      roleName
    }
  }
}
    `;
export function useCreateUserMutation() {
    return Urql.useMutation(CreateUserDocument);
}
;
export const UpdateUserDocument = gql `
    mutation UpdateUser($input: UserUpdateInput!) {
  users {
    updateUser(input: $input) {
      userId
      firstName
      lastName
      email
      phoneNumber
      imageUrl
      isActive
      roleName
      daysAvailable
      about
      notes
      educationAndCertifications
      preferredAges
      locations {
        locationId
        name
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      therapySubCategories {
        therapySubCategoryId
        name
      }
    }
  }
}
    `;
export function useUpdateUserMutation() {
    return Urql.useMutation(UpdateUserDocument);
}
;
export const MasqueradeDocument = gql `
    mutation Masquerade($organizationId: String) {
  users {
    masquerade(organizationId: $organizationId) {
      success
    }
  }
}
    `;
export function useMasqueradeMutation() {
    return Urql.useMutation(MasqueradeDocument);
}
;
export const ExportDataDocument = gql `
    mutation ExportData($exportOrganizations: Boolean, $exportOrganizationAdmins: Boolean, $exportProviders: Boolean, $exportCaseManagers: Boolean, $exportCaregivers: Boolean, $exportLocations: Boolean, $exportPhoneNumber: Boolean, $exportEmail: Boolean) {
  data {
    exportData(
      exportOrganizations: $exportOrganizations
      exportOrganizationAdmins: $exportOrganizationAdmins
      exportProviders: $exportProviders
      exportCaseManagers: $exportCaseManagers
      exportCaregivers: $exportCaregivers
      exportLocations: $exportLocations
      exportPhoneNumber: $exportPhoneNumber
      exportEmail: $exportEmail
    ) {
      id
      organizationId
      organizationName
      organizationTypes
      numberOfProviders
      name
      phoneNumber
      email
      active
      termsAndConditions
      address1
      address2
      city
      stateId
      postalCode
    }
  }
}
    `;
export function useExportDataMutation() {
    return Urql.useMutation(ExportDataDocument);
}
;
export const GetAiQuerySummariesDocument = gql `
    query GetAIQuerySummaries($search: String, $offset: Int) {
  ai {
    querySummaries(search: $search, offset: $offset) {
      aiQuerySummaryId
      chatSeriesId
      summary
      createdAt
    }
  }
}
    `;
export function useGetAiQuerySummariesQuery(options) {
    return Urql.useQuery({ query: GetAiQuerySummariesDocument, ...options });
}
;
export const GetAiQuerySummaryDocument = gql `
    query GetAIQuerySummary($chatSeriesId: String!) {
  ai {
    querySummary(chatSeriesId: $chatSeriesId) {
      summary
    }
  }
}
    `;
export function useGetAiQuerySummaryQuery(options) {
    return Urql.useQuery({ query: GetAiQuerySummaryDocument, ...options });
}
;
export const GetAiQueryChatSeriesDocument = gql `
    query GetAIQueryChatSeries($chatSeriesId: String!) {
  ai {
    queryChatSeries(chatSeriesId: $chatSeriesId) {
      aiQueryRequestId
      user {
        userId
        name
        imageUrl
      }
      naturalLanguageQuery
      aiResponseNotes
      hasSql
      createdAt
    }
  }
}
    `;
export function useGetAiQueryChatSeriesQuery(options) {
    return Urql.useQuery({ query: GetAiQueryChatSeriesDocument, ...options });
}
;
export const GetChatMessagesDocument = gql `
    query GetChatMessages($chatRoomId: String!, $cursor: String, $limit: Int) {
  chatMessages {
    messages(chatRoomId: $chatRoomId, cursor: $cursor, limit: $limit) {
      messages {
        chatMessageId
        chatRoomId
        senderUserId
        threadParentId
        content
        contentText
        isEdited
        isDeleted
        threadReplyCount
        threadLastReplyAt
        senderFirstName
        senderLastName
        senderImageUrl
        isPinned
        createdAt
        updatedAt
        reactions {
          chatReactionId
          chatMessageId
          userId
          emoji
          createdAt
          firstName
          lastName
        }
      }
      cursor
      hasMore
    }
  }
}
    `;
export function useGetChatMessagesQuery(options) {
    return Urql.useQuery({ query: GetChatMessagesDocument, ...options });
}
;
export const GetThreadMessagesDocument = gql `
    query GetThreadMessages($threadParentId: String!) {
  chatMessages {
    threadMessages(threadParentId: $threadParentId) {
      chatMessageId
      chatRoomId
      senderUserId
      threadParentId
      content
      contentText
      isEdited
      isDeleted
      threadReplyCount
      threadLastReplyAt
      senderFirstName
      senderLastName
      senderImageUrl
      isPinned
      createdAt
      updatedAt
      reactions {
        chatReactionId
        chatMessageId
        userId
        emoji
        createdAt
        firstName
        lastName
      }
    }
  }
}
    `;
export function useGetThreadMessagesQuery(options) {
    return Urql.useQuery({ query: GetThreadMessagesDocument, ...options });
}
;
export const GetPinnedMessagesDocument = gql `
    query GetPinnedMessages($chatRoomId: String!) {
  chatMessages {
    pinnedMessages(chatRoomId: $chatRoomId) {
      chatMessageId
      chatRoomId
      senderUserId
      content
      contentText
      isEdited
      senderFirstName
      senderLastName
      senderImageUrl
      isPinned
      createdAt
      reactions {
        chatReactionId
        chatMessageId
        userId
        emoji
        createdAt
        firstName
        lastName
      }
    }
  }
}
    `;
export function useGetPinnedMessagesQuery(options) {
    return Urql.useQuery({ query: GetPinnedMessagesDocument, ...options });
}
;
export const GetChatRoomsDocument = gql `
    query GetChatRooms($type: ChatRoomTypeEnum, $isArchived: Boolean) {
  chatRooms {
    rooms(type: $type, isArchived: $isArchived) {
      chatRoomId
      type
      name
      description
      isGroupDm
      isArchived
      lastMessageAt
      createdByUserId
      caregiverId
      patientId
      createdAt
      unreadCount
      lastMessage {
        chatMessageId
        contentText
        senderUserId
        senderFirstName
        senderLastName
        createdAt
      }
      members {
        chatRoomMemberId
        userId
        firstName
        lastName
        email
        imageUrl
        lastReadAt
        isMuted
        joinedAt
      }
    }
  }
}
    `;
export function useGetChatRoomsQuery(options) {
    return Urql.useQuery({ query: GetChatRoomsDocument, ...options });
}
;
export const GetChatRoomDocument = gql `
    query GetChatRoom($chatRoomId: String!) {
  chatRooms {
    room(chatRoomId: $chatRoomId) {
      chatRoomId
      type
      name
      description
      isGroupDm
      isArchived
      lastMessageAt
      createdByUserId
      caregiverId
      patientId
      createdAt
      unreadCount
      members {
        chatRoomMemberId
        userId
        firstName
        lastName
        email
        imageUrl
        lastReadAt
        isMuted
        joinedAt
      }
    }
  }
}
    `;
export function useGetChatRoomQuery(options) {
    return Urql.useQuery({ query: GetChatRoomDocument, ...options });
}
;
export const SearchChatMessagesDocument = gql `
    query SearchChatMessages($query: String!, $limit: Int) {
  chatRooms {
    search(query: $query, limit: $limit) {
      message {
        chatMessageId
        contentText
        senderFirstName
        senderLastName
        createdAt
        chatRoomId
      }
      room {
        chatRoomId
        name
        type
      }
    }
  }
}
    `;
export function useSearchChatMessagesQuery(options) {
    return Urql.useQuery({ query: SearchChatMessagesDocument, ...options });
}
;
export const CaseManagerDrawerDocument = gql `
    query CaseManagerDrawer($organizationId: String) {
  locations {
    locationsList(organizationId: $organizationId) {
      value
      label
    }
  }
}
    `;
export function useCaseManagerDrawerQuery(options) {
    return Urql.useQuery({ query: CaseManagerDrawerDocument, ...options });
}
;
export const OrganizationAdminDrawerDocument = gql `
    query OrganizationAdminDrawer($organizationId: String) {
  locations {
    locationsList(organizationId: $organizationId) {
      value
      label
    }
  }
}
    `;
export function useOrganizationAdminDrawerQuery(options) {
    return Urql.useQuery({ query: OrganizationAdminDrawerDocument, ...options });
}
;
export const OrganizationDrawerDocument = gql `
    query OrganizationDrawer($organizationId: String) {
  organizations {
    organization(organizationId: $organizationId) {
      organizationId
      npiNumber
      name
      phoneNumber
      email
      about
      notes
      organizationTypes
      websiteUrl
      createdAt
      isActive
      insuranceIds
      therapyCategoryIds
      imageUrl
    }
  }
}
    `;
export function useOrganizationDrawerQuery(options) {
    return Urql.useQuery({ query: OrganizationDrawerDocument, ...options });
}
;
export const OrganizationEntityListDocument = gql `
    query OrganizationEntityList {
  insurances {
    insurancesList {
      value
      label
    }
  }
  therapyCategories {
    therapyCategoriesList {
      value
      label
    }
  }
}
    `;
export function useOrganizationEntityListQuery(options) {
    return Urql.useQuery({ query: OrganizationEntityListDocument, ...options });
}
;
export const PatientDrawerDocument = gql `
    query PatientDrawer($patientId: String!) {
  patients {
    patient(patientId: $patientId) {
      patientId
      caregiverId
      firstName
      lastName
      postalCode
      dateOfBirth
      preferredLanguages
      gradeLevel
      daysAvailable
      timeAvailable
      providers {
        userId
      }
      insuranceList {
        value
        label
      }
      conditionList {
        value
        label
      }
      therapyCategoryList {
        value
        label
      }
      therapySubCategoryList {
        value
        label
      }
    }
  }
}
    `;
export function usePatientDrawerQuery(options) {
    return Urql.useQuery({ query: PatientDrawerDocument, ...options });
}
;
export const EntityListDocument = gql `
    query EntityList {
  users {
    users(roleNames: [Provider]) {
      userId
      firstName
      lastName
      imageUrl
    }
  }
  conditions {
    conditionsList {
      value
      label
    }
  }
  insurances {
    insurancesList {
      value
      label
    }
  }
  therapyCategories {
    therapyCategoriesList {
      value
      label
    }
  }
}
    `;
export function useEntityListQuery(options) {
    return Urql.useQuery({ query: EntityListDocument, ...options });
}
;
export const PriorityEntryModalDocument = gql `
    query PriorityEntryModal($inOrganization: Boolean) {
  users {
    users(roleNames: [Provider]) {
      userId
      firstName
      lastName
      imageUrl
    }
  }
  priorityStatuses {
    priorityStatuses {
      priorityStatusId
      name
      colorHex
      sortOrder
      isMutable
      simpleEmailTemplateId
    }
  }
  conditions {
    conditionsList {
      value
      label
    }
  }
  insurances {
    insurancesList {
      value
      label
    }
  }
  therapyCategories {
    therapyCategoriesList(inOrganization: $inOrganization) {
      value
      label
    }
  }
}
    `;
export function usePriorityEntryModalQuery(options) {
    return Urql.useQuery({ query: PriorityEntryModalDocument, ...options });
}
;
export const ProviderDrawerDocument = gql `
    query ProviderDrawer($inOrganization: Boolean, $organizationId: String) {
  locations {
    locationsList(organizationId: $organizationId) {
      value
      label
    }
  }
  therapyCategories {
    therapyCategoriesList(
      inOrganization: $inOrganization
      organizationId: $organizationId
    ) {
      value
      label
    }
  }
}
    `;
export function useProviderDrawerQuery(options) {
    return Urql.useQuery({ query: ProviderDrawerDocument, ...options });
}
;
export const GlobalSearchDocument = gql `
    query GlobalSearch($query: String!) {
  globalSearch {
    search(query: $query) {
      users {
        id
        name
        type
        description
        imageUrl
      }
      patients {
        id
        name
        type
        description
        imageUrl
      }
      organizations {
        id
        name
        type
        description
        imageUrl
      }
    }
  }
}
    `;
export function useGlobalSearchQuery(options) {
    return Urql.useQuery({ query: GlobalSearchDocument, ...options });
}
;
export const GetSubscriptionCountsDocument = gql `
    query GetSubscriptionCounts {
  chatRooms {
    chatUnreadCount
  }
  priorityReferrals {
    priorityReferralCount
  }
  websiteLeads {
    websiteLeadCount
  }
}
    `;
export function useGetSubscriptionCountsQuery(options) {
    return Urql.useQuery({ query: GetSubscriptionCountsDocument, ...options });
}
;
export const GetFamilyRoomPatientsDocument = gql `
    query GetFamilyRoomPatients($search: String) {
  patients {
    familyRoomPatients(search: $search) {
      patientId
      firstName
      lastName
      caregiver {
        userId
        firstName
        lastName
      }
    }
  }
}
    `;
export function useGetFamilyRoomPatientsQuery(options) {
    return Urql.useQuery({ query: GetFamilyRoomPatientsDocument, ...options });
}
;
export const GetPriorityEmailRecordsDocument = gql `
    query GetPriorityEmailRecords($search: String, $offset: Int, $type: PriorityEmailType) {
  priorityEmailRecords {
    priorityEmailRecords(search: $search, offset: $offset, type: $type) {
      priorityEmailRecordId
      priorityEmailAction
      email
      priorityEntry {
        patient {
          patientId
          firstName
          lastName
          dateOfBirth
          postalCodeInfo {
            city
            stateId
            postalCode
          }
        }
        therapyCategory {
          therapyCategoryId
          name
        }
        caregiver {
          userId
          firstName
          lastName
          email
          phoneNumber
        }
      }
      invitingUser {
        userId
        name
        email
        imageUrl
      }
      updatedAt
    }
  }
}
    `;
export function useGetPriorityEmailRecordsQuery(options) {
    return Urql.useQuery({ query: GetPriorityEmailRecordsDocument, ...options });
}
;
export const GetPriorityEmailRecordCountDocument = gql `
    query GetPriorityEmailRecordCount($search: String, $type: PriorityEmailType) {
  priorityEmailRecords {
    priorityEmailRecordCount(search: $search, type: $type)
  }
}
    `;
export function useGetPriorityEmailRecordCountQuery(options) {
    return Urql.useQuery({ query: GetPriorityEmailRecordCountDocument, ...options });
}
;
export const GetMeDocument = gql `
    query GetMe {
  users {
    me {
      id: userId
      organizationId
      masqueradeOrganizationId
      roleName
      name
      email
      permissions
      imageUrl
      acceptedTermsConditionsAt
      isActive
      organization {
        organizationId
        organizationTypes
      }
    }
  }
}
    `;
export function useGetMeQuery(options) {
    return Urql.useQuery({ query: GetMeDocument, ...options });
}
;
export const GetActiveUsersDocument = gql `
    query GetActiveUsers($search: String) {
  users {
    users(isActive: true, search: $search) {
      userId
      name
      imageUrl
      email
    }
  }
}
    `;
export function useGetActiveUsersQuery(options) {
    return Urql.useQuery({ query: GetActiveUsersDocument, ...options });
}
;
export const GetTeamMemberDocument = gql `
    query GetTeamMember($userId: String!) {
  users {
    user(userId: $userId) {
      userId
      firstName
      lastName
      email
      phoneNumber
      imageKey
      imageVersion
      imageUrl
      isActive
      roleName
      daysAvailable
      about
      notes
      educationAndCertifications
      preferredAges
      locations {
        locationId
        name
      }
      therapyCategory {
        therapyCategoryId
        name
      }
      therapySubCategories {
        therapySubCategoryId
        name
      }
      patients {
        patientId
        firstName
        lastName
        dateOfBirth
        daysAvailable
        postalCode
        gradeLevel
        isActive
        createdAt
        postalCodeInfo {
          stateId
          city
        }
      }
    }
  }
}
    `;
export function useGetTeamMemberQuery(options) {
    return Urql.useQuery({ query: GetTeamMemberDocument, ...options });
}
;
export const GetTeamMembersDocument = gql `
    query GetTeamMembers($search: String, $offset: Int, $roleNames: [UserRoleEnum!], $isActive: Boolean, $locationIds: [String], $includeTotalCount: Boolean!) {
  users {
    users(
      search: $search
      offset: $offset
      roleNames: $roleNames
      isActive: $isActive
      locationIds: $locationIds
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      imageUrl
      isActive
      roleName
      daysAvailable
      locations {
        locationId
        name
        address1
        city
        stateId
      }
    }
    userCount(
      search: $search
      roleNames: $roleNames
      isActive: $isActive
      locationIds: $locationIds
    ) @include(if: $includeTotalCount)
  }
}
    `;
export function useGetTeamMembersQuery(options) {
    return Urql.useQuery({ query: GetTeamMembersDocument, ...options });
}
;
export const ChatMessageReceivedDocument = gql `
    subscription ChatMessageReceived {
  chatMessageReceived {
    chatMessageId
    chatRoomId
    senderUserId
    threadParentId
    content
    contentText
    isEdited
    isDeleted
    threadReplyCount
    threadLastReplyAt
    senderFirstName
    senderLastName
    senderImageUrl
    isPinned
    createdAt
    updatedAt
    reactions {
      chatReactionId
      chatMessageId
      userId
      emoji
      createdAt
      firstName
      lastName
    }
  }
}
    `;
export function useChatMessageReceivedSubscription(options, handler) {
    return Urql.useSubscription({ query: ChatMessageReceivedDocument, ...options }, handler);
}
;
export const ChatMessageUpdatedDocument = gql `
    subscription ChatMessageUpdated {
  chatMessageUpdated {
    chatMessageId
    chatRoomId
    updateType
    message {
      chatMessageId
      chatRoomId
      senderUserId
      threadParentId
      content
      contentText
      isEdited
      isDeleted
      threadReplyCount
      threadLastReplyAt
      senderFirstName
      senderLastName
      senderImageUrl
      isPinned
      createdAt
      updatedAt
      reactions {
        chatReactionId
        chatMessageId
        userId
        emoji
        createdAt
        firstName
        lastName
      }
    }
  }
}
    `;
export function useChatMessageUpdatedSubscription(options, handler) {
    return Urql.useSubscription({ query: ChatMessageUpdatedDocument, ...options }, handler);
}
;
export const ChatRoomUpdatedDocument = gql `
    subscription ChatRoomUpdated {
  chatRoomUpdated {
    chatRoomId
    updateType
    room {
      chatRoomId
      type
      name
      description
      isGroupDm
      isArchived
      lastMessageAt
      createdByUserId
      createdAt
      updatedAt
      members {
        chatRoomMemberId
        userId
        firstName
        lastName
        email
        imageUrl
        lastReadAt
        isMuted
        joinedAt
      }
    }
  }
}
    `;
export function useChatRoomUpdatedSubscription(options, handler) {
    return Urql.useSubscription({ query: ChatRoomUpdatedDocument, ...options }, handler);
}
;
